/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Action = {
  __typename?: 'Action';
  actionUid: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  expireAt?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum ActionType {
  End = 'END',
  Goto = 'GOTO',
  Next = 'NEXT'
}

export type AddAlertInput = {
  expertChannels: Array<InputMaybe<Scalars['String']['input']>>;
  expertUid: Scalars['String']['input'];
  notificationChannels: Array<InputMaybe<Scalars['String']['input']>>;
};

export type Advisory = {
  __typename?: 'Advisory';
  acknowledgedAt?: Maybe<Scalars['String']['output']>;
  acknowledgedUid?: Maybe<Scalars['String']['output']>;
  actionable?: Maybe<Scalars['Boolean']['output']>;
  advisoryUid: Scalars['String']['output'];
  context?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  lastSeenAt?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  severityRating: Scalars['Int']['output'];
  sourceType: Scalars['String']['output'];
  sourceUid?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  targetAckAt?: Maybe<Scalars['String']['output']>;
  targetType: Scalars['String']['output'];
  targetUid?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type AdvisoryMutations = {
  __typename?: 'AdvisoryMutations';
  acknowledgeAdvisory?: Maybe<Scalars['Boolean']['output']>;
};


export type AdvisoryMutationsAcknowledgeAdvisoryArgs = {
  advisoryUid?: InputMaybe<Scalars['String']['input']>;
};

export type Announcement = {
  __typename?: 'Announcement';
  announcementUid: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notify?: Maybe<Scalars['Boolean']['output']>;
  startDate: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  typeData: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type AnnouncementMutations = {
  __typename?: 'AnnouncementMutations';
  ackAnnouncements?: Maybe<Scalars['Boolean']['output']>;
};


export type AnnouncementMutationsAckAnnouncementsArgs = {
  announcementUids: Array<InputMaybe<Scalars['String']['input']>>;
};

export type AnonymizedQueueInfo = {
  __typename?: 'AnonymizedQueueInfo';
  context: Scalars['String']['output'];
  dropAt?: Maybe<Scalars['String']['output']>;
  items: Array<Maybe<QueueItem>>;
  metadata?: Maybe<QueueItemMetadata>;
  queueItemType?: Maybe<QueueType>;
  queueItemUid?: Maybe<Scalars['String']['output']>;
  queueType: Scalars['String']['output'];
  queueUid: Scalars['String']['output'];
  queuedAt: Scalars['String']['output'];
  targetUid: Scalars['String']['output'];
};

export type AnonymizedQueueItem = {
  __typename?: 'AnonymizedQueueItem';
  duration?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<AnonymizedQueueItemMetadata>;
  position?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AnonymizedQueueItemMetadata = {
  __typename?: 'AnonymizedQueueItemMetadata';
  isEphemeral?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Int']['output']>;
};

export type Article = {
  __typename?: 'Article';
  articleUid: Scalars['ID']['output'];
  author: Author;
  authorUid: Scalars['ID']['output'];
  categories?: Maybe<Array<Maybe<ArticleCategory>>>;
  categoryUids: Array<Maybe<Scalars['ID']['output']>>;
  content?: Maybe<Array<Maybe<ArticleContent>>>;
  context?: Maybe<Scalars['String']['output']>;
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  coverImageUrls?: Maybe<Array<Maybe<LocalisedField>>>;
  imageAlts?: Maybe<Array<Maybe<LocalisedField>>>;
  postscript?: Maybe<ArticlePostscript>;
  publishAt?: Maybe<Scalars['String']['output']>;
  reserved?: Maybe<Scalars['Boolean']['output']>;
  shortLinkSlug?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type ArticleCategoriesSearch = {
  authorUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ArticleCategory = {
  __typename?: 'ArticleCategory';
  categoryUid: Scalars['ID']['output'];
  color?: Maybe<Scalars['String']['output']>;
  descriptions?: Maybe<Array<Maybe<LocalisedField>>>;
  imageAlts?: Maybe<Array<Maybe<LocalisedField>>>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  imageUrls?: Maybe<Array<Maybe<LocalisedField>>>;
  marketingOffers?: Maybe<Array<Maybe<MarketingOffer>>>;
  slugs?: Maybe<Array<Maybe<LocalisedField>>>;
  titleKey?: Maybe<Scalars['String']['output']>;
  titles?: Maybe<Array<Maybe<LocalisedField>>>;
};

export type ArticleCategoryBreakdown = {
  __typename?: 'ArticleCategoryBreakdown';
  articleCount: Scalars['Int']['output'];
  categoryUid: Scalars['ID']['output'];
  titleKey: Scalars['String']['output'];
};

export type ArticleContent = {
  __typename?: 'ArticleContent';
  articleContentUid: Scalars['ID']['output'];
  articleUid: Scalars['ID']['output'];
  body?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  nextBody?: Maybe<Scalars['String']['output']>;
  nextSummary?: Maybe<Scalars['String']['output']>;
  nextTitle?: Maybe<Scalars['String']['output']>;
  nextTldr?: Maybe<Scalars['String']['output']>;
  readingTime?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tldr?: Maybe<Scalars['String']['output']>;
};

export type ArticleContentSummary = {
  __typename?: 'ArticleContentSummary';
  language: Scalars['String']['output'];
  readingTime?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  status: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ArticlePostscript = {
  __typename?: 'ArticlePostscript';
  app?: Maybe<Scalars['Boolean']['output']>;
  newsletter?: Maybe<Scalars['Boolean']['output']>;
  signup?: Maybe<Scalars['Boolean']['output']>;
};

export type ArticleSummary = {
  __typename?: 'ArticleSummary';
  articleUid: Scalars['ID']['output'];
  author?: Maybe<Author>;
  authorUid: Scalars['ID']['output'];
  categories?: Maybe<Array<Maybe<ArticleCategory>>>;
  categoryUids: Array<Maybe<Scalars['String']['output']>>;
  content: ArticleContentSummary;
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  coverImageUrls?: Maybe<Array<Maybe<LocalisedField>>>;
  imageAlts?: Maybe<Array<Maybe<LocalisedField>>>;
  publishAt: Scalars['String']['output'];
  reserved?: Maybe<Scalars['Boolean']['output']>;
  shortLinkSlug?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type ArticleSummaryList = {
  __typename?: 'ArticleSummaryList';
  data: Array<Maybe<ArticleSummary>>;
  totalRows: Scalars['Int']['output'];
};

export type ArticleSummarySearch = {
  authorUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeReserved?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ArticlesCategoryBreakdownSearch = {
  categoryUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeReserved?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
};

export type AuthMutations = {
  __typename?: 'AuthMutations';
  passwordRecovery?: Maybe<Scalars['Boolean']['output']>;
  passwordReset?: Maybe<Scalars['Boolean']['output']>;
};


export type AuthMutationsPasswordRecoveryArgs = {
  email: Scalars['String']['input'];
  language: Scalars['String']['input'];
};


export type AuthMutationsPasswordResetArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type Author = {
  __typename?: 'Author';
  authorUid: Scalars['ID']['output'];
  avatarUrl?: Maybe<Scalars['String']['output']>;
  avatarUrls?: Maybe<Array<Maybe<LocalisedField>>>;
  context: Scalars['String']['output'];
  descriptions?: Maybe<Array<Maybe<LocalisedField>>>;
  imageAlts?: Maybe<Array<Maybe<LocalisedField>>>;
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  titleKey?: Maybe<Scalars['String']['output']>;
  titles?: Maybe<Array<Maybe<LocalisedField>>>;
};

export type Boost = {
  __typename?: 'Boost';
  boostUid: Scalars['ID']['output'];
  channels: Array<Maybe<BoostChannel>>;
  endDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export enum BoostChannel {
  Livechat = 'LIVECHAT',
  Phone = 'PHONE',
  Video = 'VIDEO',
  Written = 'WRITTEN'
}

export type Consent = {
  __typename?: 'Consent';
  consentDate?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  context: Scalars['String']['output'];
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  purposeKey: Scalars['String']['output'];
  purposeUid: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  requiresConsent?: Maybe<Scalars['Boolean']['output']>;
  type: ConsentType;
  userUid: Scalars['String']['output'];
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type ConsentInput = {
  purposeUid: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export enum ConsentType {
  Agreement = 'AGREEMENT',
  Cookie = 'COOKIE',
  Subscription = 'SUBSCRIPTION'
}

export type Consultation = {
  __typename?: 'Consultation';
  boost?: Maybe<Boost>;
  channel: Scalars['String']['output'];
  channelRefUid: Scalars['String']['output'];
  consultationUid: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  expertUid: Scalars['String']['output'];
  failReason?: Maybe<Scalars['String']['output']>;
  language: Scalars['String']['output'];
  maxDuration?: Maybe<Scalars['Int']['output']>;
  memberUid?: Maybe<Scalars['String']['output']>;
  purgeDate?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<ConsultationRating>;
  startDate?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type ConsultationCallProperties = {
  callType: Scalars['String']['input'];
  ivrCallUid?: InputMaybe<Scalars['String']['input']>;
  phoneUid?: InputMaybe<Scalars['String']['input']>;
};

export enum ConsultationChannel {
  Livechat = 'LIVECHAT',
  Phone = 'PHONE',
  Video = 'VIDEO',
  Written = 'WRITTEN'
}

export type ConsultationFilters = {
  expertUid?: InputMaybe<Scalars['String']['input']>;
  livechat?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  rated?: InputMaybe<Scalars['Boolean']['input']>;
  video?: InputMaybe<Scalars['Boolean']['input']>;
  written?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConsultationList = {
  __typename?: 'ConsultationList';
  data: Array<Maybe<Consultation>>;
  totalRows: Scalars['Int']['output'];
};

export type ConsultationLivechatInput = {
  expertUid: Scalars['String']['input'];
  language: Scalars['String']['input'];
};

export type ConsultationMutations = {
  __typename?: 'ConsultationMutations';
  addConsultationRating?: Maybe<ConsultationRating>;
  createConsultationWritten?: Maybe<Consultation>;
  purgeConsultation?: Maybe<Scalars['String']['output']>;
  stopLivechatConsultation?: Maybe<Scalars['Boolean']['output']>;
  stopVideoConsultation?: Maybe<Scalars['Boolean']['output']>;
  trialConsultationFeedback?: Maybe<Scalars['Boolean']['output']>;
  trialOfferAction?: Maybe<Scalars['Boolean']['output']>;
  updateConsultationRating?: Maybe<ConsultationRating>;
};


export type ConsultationMutationsAddConsultationRatingArgs = {
  input: ConsultationRatingInput;
};


export type ConsultationMutationsCreateConsultationWrittenArgs = {
  input: ConsultationWrittenInput;
};


export type ConsultationMutationsPurgeConsultationArgs = {
  consultationUid: Scalars['String']['input'];
};


export type ConsultationMutationsStopLivechatConsultationArgs = {
  livechatRoomUid: Scalars['String']['input'];
};


export type ConsultationMutationsStopVideoConsultationArgs = {
  videoRoomUid: Scalars['String']['input'];
};


export type ConsultationMutationsTrialConsultationFeedbackArgs = {
  feedback?: InputMaybe<TrialConsultationFeedback>;
  trialConsultationUid: Scalars['String']['input'];
  trialUid: Scalars['String']['input'];
};


export type ConsultationMutationsTrialOfferActionArgs = {
  action: TrialOfferAction;
  trialOfferUid: Scalars['String']['input'];
};


export type ConsultationMutationsUpdateConsultationRatingArgs = {
  input: ConsultationRatingInput;
  ratingUid: Scalars['String']['input'];
};

export type ConsultationPhoneInput = {
  callProperties?: InputMaybe<ConsultationCallProperties>;
  expertUid: Scalars['String']['input'];
  language: Scalars['String']['input'];
  memberUid?: InputMaybe<Scalars['String']['input']>;
};

export type ConsultationRating = {
  __typename?: 'ConsultationRating';
  comment: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  moderation?: Maybe<Scalars['Boolean']['output']>;
  postponed?: Maybe<Scalars['Boolean']['output']>;
  rate: Scalars['Int']['output'];
  ratingAnswer?: Maybe<RatingAnswer>;
  ratingUid: Scalars['String']['output'];
  refused?: Maybe<Scalars['Boolean']['output']>;
  rejected?: Maybe<Scalars['Boolean']['output']>;
  validationComment?: Maybe<Scalars['String']['output']>;
};

export type ConsultationRatingInput = {
  comment: Scalars['String']['input'];
  consultationUid: Scalars['String']['input'];
  rate: Scalars['Int']['input'];
};

export type ConsultationWrittenInput = {
  attachments: Array<InputMaybe<Scalars['String']['input']>>;
  expertUid: Scalars['String']['input'];
  language: Scalars['String']['input'];
  message: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type Content = {
  __typename?: 'Content';
  content?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  namespace?: Maybe<Scalars['String']['output']>;
};

export type CreateMemberConsent = {
  exclusiveOffersConsent: Scalars['Boolean']['input'];
  newsletterConsent: Scalars['Boolean']['input'];
};

export type CreateOrderInput = {
  currency: Scalars['String']['input'];
  packUid: Scalars['String']['input'];
  paymentMetadata?: InputMaybe<Scalars['String']['input']>;
  paymentMethodUid?: InputMaybe<Scalars['String']['input']>;
  promoUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  redirectUrl: Scalars['String']['input'];
};

export type CreateTicketInput = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content: Scalars['String']['input'];
  language: Scalars['String']['input'];
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  relation?: InputMaybe<RelationInput>;
  subject: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
  userFirstname?: InputMaybe<Scalars['String']['input']>;
  userLastname?: InputMaybe<Scalars['String']['input']>;
  userPseudo?: InputMaybe<Scalars['String']['input']>;
};

export type DailyHoroscope = {
  __typename?: 'DailyHoroscope';
  family?: Maybe<Scalars['String']['output']>;
  health?: Maybe<Scalars['String']['output']>;
  love?: Maybe<Scalars['String']['output']>;
  luckyNumber?: Maybe<Scalars['Int']['output']>;
  main?: Maybe<Scalars['String']['output']>;
  money?: Maybe<Scalars['String']['output']>;
  quote?: Maybe<Scalars['String']['output']>;
  sign?: Maybe<Scalars['String']['output']>;
  socialLife?: Maybe<Scalars['String']['output']>;
  wink?: Maybe<Scalars['String']['output']>;
  work?: Maybe<Scalars['String']['output']>;
};

export type DisplayPhone = {
  __typename?: 'DisplayPhone';
  communications?: Maybe<PhoneCommunications>;
  country?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  phoneUid: Scalars['String']['output'];
  usage: DisplayPhoneUsage;
};

export enum DisplayPhoneUsage {
  Prepaid = 'PREPAID',
  Surtaxed = 'SURTAXED'
}

export type DropQueueResult = {
  __typename?: 'DropQueueResult';
  success: Scalars['Boolean']['output'];
};

export type EditAlertInput = {
  alertUid: Scalars['String']['input'];
  expertChannels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notificationChannels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  renewValidity?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Expert = {
  __typename?: 'Expert';
  content?: Maybe<ExpertContent>;
  createdAt?: Maybe<Scalars['String']['output']>;
  expertCode?: Maybe<Scalars['String']['output']>;
  expertUid: Scalars['ID']['output'];
  parameters?: Maybe<ExpertParameters>;
  picture?: Maybe<Scalars['String']['output']>;
  planning?: Maybe<ExpertPlanningWeek>;
  presenceStatus?: Maybe<ExpertStatus>;
  pseudo?: Maybe<Scalars['String']['output']>;
  queue?: Maybe<AnonymizedQueueInfo>;
  quote?: Maybe<Scalars['String']['output']>;
  skills?: Maybe<Array<Maybe<Skills>>>;
  spokenLanguages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  totalConsultations?: Maybe<Scalars['Int']['output']>;
  totalRatings?: Maybe<Scalars['Int']['output']>;
  vocalMessage?: Maybe<Scalars['String']['output']>;
};

export type ExpertContent = {
  __typename?: 'ExpertContent';
  description?: Maybe<Scalars['String']['output']>;
  writtenMessage?: Maybe<Scalars['String']['output']>;
};

export type ExpertDataFilters = {
  expertUids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type ExpertIdentifiers = {
  __typename?: 'ExpertIdentifiers';
  createdAt?: Maybe<Scalars['String']['output']>;
  expertCode?: Maybe<Scalars['String']['output']>;
  expertUid: Scalars['ID']['output'];
  hidden?: Maybe<Scalars['Boolean']['output']>;
  online?: Maybe<Scalars['Boolean']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  pseudo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ExpertLimits = {
  __typename?: 'ExpertLimits';
  availableMessageNbr?: Maybe<Scalars['Int']['output']>;
  consultationSecondCtr?: Maybe<Scalars['Int']['output']>;
};

export type ExpertListFilters = {
  consultationType?: InputMaybe<Array<InputMaybe<ConsultationChannel>>>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderBy?: InputMaybe<ExpertListOrder>;
  profileLanguage?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<InputMaybe<Skills>>>;
};

export enum ExpertListOrder {
  Consultation = 'CONSULTATION',
  Evaluation = 'EVALUATION',
  LivechatConsultation = 'LIVECHAT_CONSULTATION',
  Longevity = 'LONGEVITY',
  Newest = 'NEWEST',
  PhoneConsultation = 'PHONE_CONSULTATION',
  VideoConsultation = 'VIDEO_CONSULTATION',
  WrittenConsultation = 'WRITTEN_CONSULTATION'
}

export type ExpertParameters = {
  __typename?: 'ExpertParameters';
  livechatEnabled?: Maybe<Scalars['Boolean']['output']>;
  phoneEnabled?: Maybe<Scalars['Boolean']['output']>;
  videoEnabled?: Maybe<Scalars['Boolean']['output']>;
  writtenEnabled?: Maybe<Scalars['Boolean']['output']>;
  writtenLimit?: Maybe<Scalars['Int']['output']>;
  writtenMode?: Maybe<Scalars['Boolean']['output']>;
};

export type ExpertPlanningQueueSlot = {
  __typename?: 'ExpertPlanningQueueSlot';
  channels?: Maybe<Array<Maybe<ConsultationChannel>>>;
  end?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type ExpertPlanningSlot = {
  __typename?: 'ExpertPlanningSlot';
  channels?: Maybe<Array<Maybe<ConsultationChannel>>>;
  end?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type ExpertPlanningWeek = {
  __typename?: 'ExpertPlanningWeek';
  from?: Maybe<Scalars['String']['output']>;
  ownerUid: Scalars['ID']['output'];
  queueSlots?: Maybe<Array<Maybe<ExpertPlanningQueueSlot>>>;
  slots?: Maybe<Array<Maybe<ExpertPlanningSlot>>>;
  to?: Maybe<Scalars['String']['output']>;
};

export type ExpertQueue = {
  __typename?: 'ExpertQueue';
  items?: Maybe<Array<Maybe<ExpertQueueItem>>>;
  queueUid?: Maybe<Scalars['String']['output']>;
};

export type ExpertQueueItem = {
  __typename?: 'ExpertQueueItem';
  duration?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
};

export type ExpertStatus = {
  __typename?: 'ExpertStatus';
  activityStatus?: Maybe<Scalars['Boolean']['output']>;
  livechatStatus?: Maybe<Scalars['Boolean']['output']>;
  phoneStatus?: Maybe<Scalars['Boolean']['output']>;
  videoStatus?: Maybe<Scalars['Boolean']['output']>;
  writtenStatus?: Maybe<Scalars['Boolean']['output']>;
};

export type Feedback = {
  __typename?: 'Feedback';
  content?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  keyLabel?: Maybe<Scalars['String']['output']>;
  type?: Maybe<FeedbackType>;
};

export type FeedbackInput = {
  content: Scalars['String']['input'];
  key: Scalars['String']['input'];
  keyLabel: Scalars['String']['input'];
  type: FeedbackType;
};

export enum FeedbackType {
  Boolean = 'BOOLEAN',
  Checkbox = 'CHECKBOX',
  Rating = 'RATING',
  Text = 'TEXT'
}

export type Global = {
  __typename?: 'Global';
  announcements?: Maybe<Array<Maybe<Announcement>>>;
  boosts?: Maybe<Array<Maybe<Boost>>>;
  ipCountry?: Maybe<Scalars['String']['output']>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
};

export type HoroscopeSubscription = {
  email: Scalars['String']['input'];
  lang: Scalars['String']['input'];
  memberUid?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  sign: Scalars['String']['input'];
};

export type HostedTokenization = {
  __typename?: 'HostedTokenization';
  tokens?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ITrialConsultationFeedback = {
  __typename?: 'ITrialConsultationFeedback';
  comment?: Maybe<Scalars['String']['output']>;
  globalQuality?: Maybe<Scalars['Int']['output']>;
  listeningQuality?: Maybe<Scalars['Int']['output']>;
  receptionQuality?: Maybe<Scalars['Int']['output']>;
  recommandation?: Maybe<Scalars['Boolean']['output']>;
  responseQuality?: Maybe<Scalars['Int']['output']>;
};

export type IvrCall = {
  __typename?: 'IVRCall';
  expertUid?: Maybe<Scalars['String']['output']>;
  ivrCallUid: Scalars['String']['output'];
  memberCallUid?: Maybe<Scalars['String']['output']>;
  memberPhone?: Maybe<Scalars['String']['output']>;
  memberUid?: Maybe<Scalars['String']['output']>;
};

export type JoinQueueActionResult = {
  __typename?: 'JoinQueueActionResult';
  memberPhoneUid?: Maybe<Scalars['String']['output']>;
  queueItemUid?: Maybe<Scalars['String']['output']>;
  servicePhone?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LivechatParticipant = {
  __typename?: 'LivechatParticipant';
  name: Scalars['String']['output'];
  userUid: Scalars['String']['output'];
};

export type LivechatRoom = {
  __typename?: 'LivechatRoom';
  context?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  livechatRoomUid: Scalars['ID']['output'];
  maxTime: Scalars['Int']['output'];
  messages?: Maybe<Array<Maybe<LivechatRoomMessages>>>;
  participants: Array<Maybe<LivechatParticipant>>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<LivechatRoomStatus>;
};

export type LivechatRoomMessages = {
  __typename?: 'LivechatRoomMessages';
  origin: Scalars['String']['output'];
  payload: Scalars['String']['output'];
  ts: Scalars['Float']['output'];
};

export enum LivechatRoomStatus {
  Canceled = 'CANCELED',
  Connected = 'CONNECTED',
  ConnectionLost = 'CONNECTION_LOST',
  Created = 'CREATED',
  Expired = 'EXPIRED',
  Finished = 'FINISHED',
  Initiated = 'INITIATED',
  Started = 'STARTED'
}

export type LocalisedField = {
  __typename?: 'LocalisedField';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type LocalisedFieldInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type LogsMutations = {
  __typename?: 'LogsMutations';
  sendEventLog?: Maybe<Scalars['Boolean']['output']>;
};


export type LogsMutationsSendEventLogArgs = {
  event: Scalars['String']['input'];
  level: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  ts: Scalars['String']['input'];
};

export type MarketingOffer = {
  __typename?: 'MarketingOffer';
  descriptions?: Maybe<Array<Maybe<LocalisedField>>>;
  imageAlts?: Maybe<Array<Maybe<LocalisedField>>>;
  imageUrls?: Maybe<Array<Maybe<LocalisedField>>>;
  titles?: Maybe<Array<Maybe<LocalisedField>>>;
};

export type Member = {
  __typename?: 'Member';
  address?: Maybe<Scalars['String']['output']>;
  alerts?: Maybe<Array<Maybe<MemberAlert>>>;
  birthday?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  complement?: Maybe<Scalars['String']['output']>;
  consents?: Maybe<Array<Maybe<Consent>>>;
  consultedExperts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  country?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  memberUid: Scalars['ID']['output'];
  minuteHistory?: Maybe<MinuteHistoryList>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumber>>>;
  profile?: Maybe<MemberProfile>;
  queueNotificationChannels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  region?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};


export type MemberMinuteHistoryArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type MemberAlert = {
  __typename?: 'MemberAlert';
  alertUid: Scalars['ID']['output'];
  expertChannels: Array<Maybe<Scalars['String']['output']>>;
  expertUid: Scalars['String']['output'];
  notificationChannels: Array<Maybe<Scalars['String']['output']>>;
  validTo?: Maybe<Scalars['String']['output']>;
};

export type MemberInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  complement?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  pseudo?: InputMaybe<Scalars['String']['input']>;
  queueNotificationChannels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  region?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type MemberMutations = {
  __typename?: 'MemberMutations';
  addAlert?: Maybe<MemberAlert>;
  addFavorite?: Maybe<Scalars['ID']['output']>;
  changeConsent?: Maybe<Consent>;
  changeConsents?: Maybe<Array<Maybe<Consent>>>;
  changeEmail?: Maybe<Scalars['Boolean']['output']>;
  changeWeeklyOrdersLimit?: Maybe<Scalars['Int']['output']>;
  closeAccount?: Maybe<Scalars['Boolean']['output']>;
  createMember?: Maybe<Member>;
  editAlert?: Maybe<MemberAlert>;
  refreshPhoneNumberCode?: Maybe<PhoneNumber>;
  removeAlert?: Maybe<Scalars['Boolean']['output']>;
  removeFavorite?: Maybe<Scalars['ID']['output']>;
  removePhoneNumber?: Maybe<Scalars['ID']['output']>;
  setPhoneNumberUsage?: Maybe<Scalars['Boolean']['output']>;
  updateMember?: Maybe<Member>;
  updatePseudo?: Maybe<MemberProfile>;
  validateEmail?: Maybe<Scalars['Boolean']['output']>;
  validatePhoneNumber?: Maybe<PhoneNumber>;
};


export type MemberMutationsAddAlertArgs = {
  input: AddAlertInput;
};


export type MemberMutationsAddFavoriteArgs = {
  favorite: Scalars['ID']['input'];
};


export type MemberMutationsChangeConsentArgs = {
  input: ConsentInput;
};


export type MemberMutationsChangeConsentsArgs = {
  input: Array<InputMaybe<ConsentInput>>;
};


export type MemberMutationsChangeEmailArgs = {
  email: Scalars['String']['input'];
};


export type MemberMutationsChangeWeeklyOrdersLimitArgs = {
  weeklyOrdersLimit: Scalars['Int']['input'];
};


export type MemberMutationsCreateMemberArgs = {
  consents: CreateMemberConsent;
  input: MemberInput;
};


export type MemberMutationsEditAlertArgs = {
  input?: InputMaybe<EditAlertInput>;
};


export type MemberMutationsRefreshPhoneNumberCodeArgs = {
  language: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  recaptcha: Scalars['String']['input'];
};


export type MemberMutationsRemoveAlertArgs = {
  alertUid: Scalars['ID']['input'];
};


export type MemberMutationsRemoveFavoriteArgs = {
  favorite: Scalars['ID']['input'];
};


export type MemberMutationsRemovePhoneNumberArgs = {
  phoneUid: Scalars['ID']['input'];
};


export type MemberMutationsSetPhoneNumberUsageArgs = {
  phoneUid?: InputMaybe<Scalars['ID']['input']>;
  usage: Scalars['String']['input'];
};


export type MemberMutationsUpdateMemberArgs = {
  input: MemberInput;
};


export type MemberMutationsUpdatePseudoArgs = {
  pseudo: Scalars['String']['input'];
};


export type MemberMutationsValidateEmailArgs = {
  code: Scalars['String']['input'];
};


export type MemberMutationsValidatePhoneNumberArgs = {
  input: PhoneNumberValidationInput;
};

export type MemberProfile = {
  __typename?: 'MemberProfile';
  advisories?: Maybe<PaginatedAdvisory>;
  createdAt?: Maybe<Scalars['String']['output']>;
  favorites?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fidelityPoints?: Maybe<Scalars['Int']['output']>;
  memberCode?: Maybe<Scalars['String']['output']>;
  phoneUidForAlerts?: Maybe<Scalars['String']['output']>;
  phoneUidLastUsed?: Maybe<Scalars['String']['output']>;
  pseudo?: Maybe<Scalars['String']['output']>;
  queueNotificationChannels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  remainingTime?: Maybe<Scalars['Int']['output']>;
  weeklyOrdersLimit?: Maybe<Scalars['Int']['output']>;
};

export type MemberServicePhones = {
  __typename?: 'MemberServicePhones';
  calls?: Maybe<Scalars['String']['output']>;
  sms?: Maybe<Scalars['String']['output']>;
};

export type Message = {
  __typename?: 'Message';
  attachments?: Maybe<Array<Scalars['String']['output']>>;
  content?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  messageUid: Scalars['String']['output'];
  recipient: Scalars['String']['output'];
  refusalReason?: Maybe<Scalars['String']['output']>;
  sender: Scalars['String']['output'];
  sentAt: Scalars['String']['output'];
  viewedAt?: Maybe<Scalars['String']['output']>;
};

export type MessagesList = {
  __typename?: 'MessagesList';
  data: Array<Message>;
  totalRows: Scalars['Int']['output'];
};

export type MessagesSummary = {
  __typename?: 'MessagesSummary';
  blocked: Scalars['Boolean']['output'];
  blockedBy: Scalars['Boolean']['output'];
  lastMsgDate?: Maybe<Scalars['String']['output']>;
  recipient: Scalars['String']['output'];
  unreadMsg: Scalars['Int']['output'];
};

export type MessagingMutations = {
  __typename?: 'MessagingMutations';
  createBlocking: Scalars['Boolean']['output'];
  createMessage: Message;
  createMessagesViews: Scalars['Boolean']['output'];
  deleteMessage: Scalars['Boolean']['output'];
};


export type MessagingMutationsCreateBlockingArgs = {
  action: Scalars['String']['input'];
  sender: Scalars['String']['input'];
};


export type MessagingMutationsCreateMessageArgs = {
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  content: Scalars['String']['input'];
  language: Scalars['String']['input'];
  recipient: Scalars['String']['input'];
};


export type MessagingMutationsCreateMessagesViewsArgs = {
  messages: Array<Scalars['String']['input']>;
};


export type MessagingMutationsDeleteMessageArgs = {
  messageUid: Scalars['String']['input'];
};

export type MinuteHistory = {
  __typename?: 'MinuteHistory';
  action: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  from: Scalars['Int']['output'];
  minuteHistoryUid: Scalars['ID']['output'];
  to: Scalars['Int']['output'];
  type: MinuteHistoryType;
};

export type MinuteHistoryList = {
  __typename?: 'MinuteHistoryList';
  data: Array<Maybe<MinuteHistory>>;
  totalRows: Scalars['Int']['output'];
};

export enum MinuteHistoryType {
  Decrease = 'DECREASE',
  Increase = 'INCREASE'
}

export type Mutation = {
  __typename?: 'Mutation';
  advisoryMutations?: Maybe<AdvisoryMutations>;
  announcementMutations?: Maybe<AnnouncementMutations>;
  authMutations?: Maybe<AuthMutations>;
  consultationMutations?: Maybe<ConsultationMutations>;
  logsMutations?: Maybe<LogsMutations>;
  memberMutations?: Maybe<MemberMutations>;
  messagingMutations?: Maybe<MessagingMutations>;
  newslettersMutations?: Maybe<NewslettersMutations>;
  notificationMutations?: Maybe<NotificationMutations>;
  ordersMutations?: Maybe<OrdersMutations>;
  paymentMutations?: Maybe<PaymentMutations>;
  promotionMutations?: Maybe<PromotionMutations>;
  queueMutations?: Maybe<QueueMutations>;
  supportMutations?: Maybe<SupportMutations>;
  surveyMutations?: Maybe<SurveyMutations>;
  twilioMutations?: Maybe<TwilioMutations>;
  userFeedbackMutations?: Maybe<UserFeedbackMutations>;
};

export type NewslettersMutations = {
  __typename?: 'NewslettersMutations';
  subscribeHoroscope?: Maybe<Scalars['Boolean']['output']>;
};


export type NewslettersMutationsSubscribeHoroscopeArgs = {
  subscription: HoroscopeSubscription;
};

export type Notification = {
  __typename?: 'Notification';
  notifications?: Maybe<Array<Maybe<NotificationData>>>;
  unreadNotificationsCount: Scalars['Int']['output'];
};


export type NotificationNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationAck = {
  __typename?: 'NotificationAck';
  ackDate: Scalars['String']['output'];
  notificationUid: Scalars['String']['output'];
};

export type NotificationData = {
  __typename?: 'NotificationData';
  ack: Scalars['Boolean']['output'];
  channel: Scalars['String']['output'];
  contactRef: Scalars['String']['output'];
  context: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  displayed: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  metadata: Scalars['String']['output'];
  notificationType: Scalars['String']['output'];
  notificationUid: Scalars['ID']['output'];
  priority: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  target: Scalars['String']['output'];
  targetType: Scalars['String']['output'];
};

export type NotificationMutations = {
  __typename?: 'NotificationMutations';
  ackAllNotifications?: Maybe<Scalars['Boolean']['output']>;
  createNotificationAck?: Maybe<NotificationAck>;
  createNotificationPushSubscription?: Maybe<Scalars['Boolean']['output']>;
};


export type NotificationMutationsCreateNotificationAckArgs = {
  notificationUid: Scalars['String']['input'];
};


export type NotificationMutationsCreateNotificationPushSubscriptionArgs = {
  subscription: Scalars['String']['input'];
};

export type Option = {
  __typename?: 'Option';
  action?: Maybe<OptionAction>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type OptionAction = {
  __typename?: 'OptionAction';
  questionUid?: Maybe<Scalars['String']['output']>;
  type: ActionType;
};

export type Order = {
  __typename?: 'Order';
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  firstPurchase?: Maybe<Scalars['Boolean']['output']>;
  grossPrice: Scalars['Float']['output'];
  memberUid: Scalars['String']['output'];
  netPrice: Scalars['Float']['output'];
  orderId: Scalars['ID']['output'];
  pack: Pack;
  paymentLink: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
  paymentRefUid: Scalars['String']['output'];
  promoUids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status: Scalars['String']['output'];
  time: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type OrderList = {
  __typename?: 'OrderList';
  data: Array<Maybe<Order>>;
  totalRows: Scalars['Int']['output'];
};

export type OrdersMutations = {
  __typename?: 'OrdersMutations';
  createOrder?: Maybe<Order>;
};


export type OrdersMutationsCreateOrderArgs = {
  input: CreateOrderInput;
  validateOrdersLimit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Pack = {
  __typename?: 'Pack';
  activated: Scalars['Boolean']['output'];
  color?: Maybe<Scalars['String']['output']>;
  fidelityPoints: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  packUid: Scalars['ID']['output'];
  prices: Array<Maybe<PackPrice>>;
  recommended: Scalars['Boolean']['output'];
  time: Scalars['Int']['output'];
};

export type PackPrice = {
  __typename?: 'PackPrice';
  currency: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type PaginatedAdvisory = {
  __typename?: 'PaginatedAdvisory';
  data: Array<Maybe<Advisory>>;
  totalRows: Scalars['Int']['output'];
};

export type PaginatedTickets = {
  __typename?: 'PaginatedTickets';
  data?: Maybe<Array<Maybe<Ticket>>>;
  totalRows: Scalars['Int']['output'];
};

export type PaymentBlocking = {
  __typename?: 'PaymentBlocking';
  createdAt?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<PaymentBlockingMetadata>;
  paymentBlockingUid?: Maybe<Scalars['String']['output']>;
  ref?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type PaymentBlockingMetadata = {
  __typename?: 'PaymentBlockingMetadata';
  orderRef?: Maybe<Scalars['String']['output']>;
};

export type PaymentCard = {
  __typename?: 'PaymentCard';
  card: Scalars['String']['output'];
  orders: Array<Maybe<PaymentOrder>>;
  paymentMethodUid: Scalars['String']['output'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  paymentMethodUid: Scalars['String']['output'];
};

export type PaymentMutations = {
  __typename?: 'PaymentMutations';
  paymentBlocking?: Maybe<Scalars['Boolean']['output']>;
  paymentUnblocking?: Maybe<Scalars['Boolean']['output']>;
};


export type PaymentMutationsPaymentBlockingArgs = {
  blockingRef: Scalars['String']['input'];
  blockingType: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
};


export type PaymentMutationsPaymentUnblockingArgs = {
  paymentBlockingUid: Scalars['String']['input'];
};

export type PaymentOrder = {
  __typename?: 'PaymentOrder';
  date?: Maybe<Scalars['String']['output']>;
  orderUid?: Maybe<Scalars['String']['output']>;
};

export type PendingActions = {
  __typename?: 'PendingActions';
  onGoingConsultation?: Maybe<Consultation>;
  trialConsultation?: Maybe<TrialConsultation>;
  trialOffer?: Maybe<TrialOffer>;
};

export type PhoneCommunications = {
  __typename?: 'PhoneCommunications';
  callDisclaimer?: Maybe<Scalars['String']['output']>;
  callPrice?: Maybe<Scalars['String']['output']>;
  callType?: Maybe<Scalars['String']['output']>;
  discontinuing?: Maybe<Scalars['String']['output']>;
  phoneUsageUid?: Maybe<Scalars['String']['output']>;
  unavailable?: Maybe<Scalars['String']['output']>;
};

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  carrier?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  phoneCode?: Maybe<Scalars['Int']['output']>;
  phoneNumber: Scalars['String']['output'];
  phoneUid: Scalars['String']['output'];
  servicePhones?: Maybe<MemberServicePhones>;
  status: Scalars['Boolean']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type PhoneNumberValidationInput = {
  phoneCode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type PromoCode = {
  __typename?: 'PromoCode';
  code: Scalars['String']['output'];
  contexts: Array<Maybe<Scalars['String']['output']>>;
  countries: Array<Maybe<Scalars['String']['output']>>;
  createdAt: Scalars['String']['output'];
  cumulative?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  firstPurchase?: Maybe<Scalars['Boolean']['output']>;
  packs: Array<Maybe<Scalars['String']['output']>>;
  promoCodeUid: Scalars['ID']['output'];
  query?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  unique?: Maybe<Scalars['Boolean']['output']>;
  users: Array<Maybe<Scalars['String']['output']>>;
  value: Scalars['Int']['output'];
  withPurchase?: Maybe<Scalars['Boolean']['output']>;
};

export enum PromoType {
  Percentage = 'PERCENTAGE',
  Time = 'TIME'
}

export type Promotion = {
  __typename?: 'Promotion';
  endDate?: Maybe<Scalars['String']['output']>;
  packs?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  promoUid?: Maybe<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PromoType>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type PromotionMutations = {
  __typename?: 'PromotionMutations';
  validatePromoCode?: Maybe<PromoCode>;
  welcomeOfferEligibility?: Maybe<Scalars['Boolean']['output']>;
  welcomeOfferRedeem?: Maybe<WelcomeOfferRedeemResult>;
};


export type PromotionMutationsValidatePromoCodeArgs = {
  code: Scalars['String']['input'];
  codes: Array<InputMaybe<Scalars['String']['input']>>;
  packUid: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  activeSurveys?: Maybe<Array<Maybe<Survey>>>;
  advisories?: Maybe<PaginatedAdvisory>;
  announcements?: Maybe<Array<Maybe<Announcement>>>;
  article?: Maybe<Article>;
  articleCategories?: Maybe<Array<Maybe<ArticleCategory>>>;
  articleCategory?: Maybe<ArticleCategory>;
  articleSummaries?: Maybe<ArticleSummaryList>;
  articlesCategoryBreakdown?: Maybe<Array<Maybe<ArticleCategoryBreakdown>>>;
  author?: Maybe<Author>;
  consultation?: Maybe<Consultation>;
  consultations?: Maybe<ConsultationList>;
  content?: Maybe<Array<Maybe<Content>>>;
  /** Get horoscope for today in the given locale and timezone. */
  dailyHoroscopes?: Maybe<Array<Maybe<DailyHoroscope>>>;
  displayPhones: Array<Maybe<DisplayPhone>>;
  expert?: Maybe<Expert>;
  expertLimits?: Maybe<ExpertLimits>;
  expertsData?: Maybe<Array<Maybe<Expert>>>;
  expertsIdentifiers?: Maybe<Array<Maybe<ExpertIdentifiers>>>;
  expertsList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getAuthToken: GetAuthToken;
  global?: Maybe<Global>;
  ivrCalls: IvrCall;
  livechatRoom?: Maybe<LivechatRoom>;
  member?: Maybe<Member>;
  messageAllowed: Scalars['Boolean']['output'];
  messagesList: MessagesList;
  messagesSummary: Array<MessagesSummary>;
  notification?: Maybe<Notification>;
  order?: Maybe<Order>;
  orderRefresh?: Maybe<Order>;
  orders?: Maybe<OrderList>;
  packs?: Maybe<Array<Maybe<Pack>>>;
  paymentBlocking?: Maybe<Array<Maybe<PaymentBlocking>>>;
  paymentCards?: Maybe<Array<Maybe<PaymentCard>>>;
  paymentHostedTokenization?: Maybe<HostedTokenization>;
  paymentMethods?: Maybe<Array<Maybe<PaymentMethod>>>;
  pendingActions?: Maybe<PendingActions>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  ratings?: Maybe<RatingList>;
  ratingsSummary?: Maybe<Array<Maybe<RatingSummary>>>;
  response?: Maybe<Array<Maybe<QuestionResponse>>>;
  survey?: Maybe<Survey>;
  ticket?: Maybe<Ticket>;
  tickets?: Maybe<PaginatedTickets>;
  trialConsultation?: Maybe<TrialConsultation>;
  trialConsultations?: Maybe<TrialConsultationList>;
  userQueues?: Maybe<Array<Maybe<AnonymizedQueueInfo>>>;
  videoRoom?: Maybe<VideoRoom>;
  written?: Maybe<Written>;
};


export type QueryAdvisoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnnouncementsArgs = {
  announcementUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArticleArgs = {
  articleUid?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArticleCategoriesArgs = {
  filters: ArticleCategoriesSearch;
};


export type QueryArticleCategoryArgs = {
  categoryUid?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  titleKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArticleSummariesArgs = {
  filters: ArticleSummarySearch;
};


export type QueryArticlesCategoryBreakdownArgs = {
  filters: ArticlesCategoryBreakdownSearch;
};


export type QueryAuthorArgs = {
  authorUid?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryConsultationArgs = {
  consultationUid: Scalars['String']['input'];
};


export type QueryConsultationsArgs = {
  filters?: InputMaybe<ConsultationFilters>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryContentArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
};


export type QueryDailyHoroscopesArgs = {
  locale: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDisplayPhonesArgs = {
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usages?: InputMaybe<Array<InputMaybe<DisplayPhoneUsage>>>;
};


export type QueryExpertArgs = {
  expertUid: Scalars['ID']['input'];
  profileLanguage: Scalars['String']['input'];
};


export type QueryExpertLimitsArgs = {
  expertUid: Scalars['String']['input'];
};


export type QueryExpertsDataArgs = {
  expertFilters: ExpertDataFilters;
};


export type QueryExpertsIdentifiersArgs = {
  profileLanguage: Scalars['String']['input'];
};


export type QueryExpertsListArgs = {
  expertFilters: ExpertListFilters;
};


export type QueryGetAuthTokenArgs = {
  idToken: Scalars['String']['input'];
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryIvrCallsArgs = {
  ivrCallUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLivechatRoomArgs = {
  livechatRoomUid: Scalars['ID']['input'];
};


export type QueryMessageAllowedArgs = {
  correspondent: Scalars['String']['input'];
};


export type QueryMessagesListArgs = {
  correspondent: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryMessagesSummaryArgs = {
  correspondent?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryOrderRefreshArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryOrdersArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryPaymentHostedTokenizationArgs = {
  locale: Scalars['String']['input'];
  paymentMethodUid: Scalars['String']['input'];
};


export type QueryPaymentMethodsArgs = {
  countryCode: Scalars['String']['input'];
};


export type QueryRatingsArgs = {
  filters?: InputMaybe<RatingFilters>;
};


export type QueryRatingsSummaryArgs = {
  filters: RatingSummaryFilters;
};


export type QueryResponseArgs = {
  questionUid: Scalars['ID']['input'];
};


export type QuerySurveyArgs = {
  surveyUid: Scalars['ID']['input'];
};


export type QueryTicketArgs = {
  ticketUid: Scalars['String']['input'];
};


export type QueryTicketsArgs = {
  filters?: InputMaybe<TicketFilters>;
};


export type QueryTrialConsultationArgs = {
  trialConsultationUid: Scalars['String']['input'];
};


export type QueryTrialConsultationsArgs = {
  filters?: InputMaybe<TrialConsultationFilters>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryVideoRoomArgs = {
  videoRoomUid: Scalars['ID']['input'];
};


export type QueryWrittenArgs = {
  writtenUid: Scalars['ID']['input'];
};

export type Question = {
  __typename?: 'Question';
  content?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  questionUid?: Maybe<Scalars['ID']['output']>;
  required: Scalars['Boolean']['output'];
  responses?: Maybe<Array<Maybe<QuestionResponse>>>;
  settings: QuestionSettings;
  showDescription: Scalars['Boolean']['output'];
  showQuestion: Scalars['Boolean']['output'];
  survey?: Maybe<Survey>;
  surveyUid: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: QuestionType;
};

export type QuestionResponse = {
  __typename?: 'QuestionResponse';
  createdAt: Scalars['String']['output'];
  questionResponseUid?: Maybe<Scalars['ID']['output']>;
  questionUid: Scalars['String']['output'];
  response: Scalars['String']['output'];
  responseUid: Scalars['String']['output'];
  userUid?: Maybe<Scalars['String']['output']>;
};

export type QuestionSettings = {
  __typename?: 'QuestionSettings';
  allowOther?: Maybe<Scalars['Boolean']['output']>;
  button?: Maybe<SettingsButton>;
  collectEmail?: Maybe<Scalars['Boolean']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxLabel?: Maybe<Scalars['String']['output']>;
  midLabel?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minLabel?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Option>>;
  step?: Maybe<Scalars['Int']['output']>;
};

export enum QuestionType {
  Conclusion = 'CONCLUSION',
  Email = 'EMAIL',
  Introduction = 'INTRODUCTION',
  LikertScale = 'LIKERT_SCALE',
  LongText = 'LONG_TEXT',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Numeric = 'NUMERIC',
  ShortText = 'SHORT_TEXT',
  UniqueChoice = 'UNIQUE_CHOICE'
}

export type QueueInfo = {
  __typename?: 'QueueInfo';
  context?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<QueueItem>>>;
  queueType?: Maybe<Scalars['String']['output']>;
  queueUid?: Maybe<Scalars['String']['output']>;
  targetUid?: Maybe<Scalars['String']['output']>;
};

export type QueueItem = {
  __typename?: 'QueueItem';
  callbackUrl?: Maybe<Scalars['String']['output']>;
  dropAt?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<QueueItemMetadata>;
  position?: Maybe<Scalars['Float']['output']>;
  queueItemUid?: Maybe<Scalars['String']['output']>;
  queueUid?: Maybe<Scalars['String']['output']>;
  queuerUid?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type QueueItemMetadata = {
  __typename?: 'QueueItemMetadata';
  isEphemeral?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Int']['output']>;
  memberPhoneUid?: Maybe<Scalars['String']['output']>;
  servicePhone?: Maybe<Scalars['String']['output']>;
};

export type QueueItemUpdate = {
  dropAt?: InputMaybe<Scalars['String']['input']>;
};

export type QueueMutations = {
  __typename?: 'QueueMutations';
  dropQueue?: Maybe<DropQueueResult>;
  editQueueItem?: Maybe<Scalars['Boolean']['output']>;
  joinQueue?: Maybe<JoinQueueActionResult>;
};


export type QueueMutationsDropQueueArgs = {
  queueItemUid: Scalars['String']['input'];
  queueUid: Scalars['String']['input'];
};


export type QueueMutationsEditQueueItemArgs = {
  queueItemUid: Scalars['String']['input'];
  queueUid: Scalars['String']['input'];
  update: QueueItemUpdate;
};


export type QueueMutationsJoinQueueArgs = {
  dropAt?: InputMaybe<Scalars['String']['input']>;
  expertUid: Scalars['String']['input'];
  language: Scalars['String']['input'];
  memberPseudo?: InputMaybe<Scalars['String']['input']>;
  phoneUid?: InputMaybe<Scalars['String']['input']>;
  queueUid: Scalars['String']['input'];
  type: QueueType;
};

export enum QueueType {
  Livechat = 'LIVECHAT',
  Phone = 'PHONE',
  Video = 'VIDEO'
}

export type Rating = {
  __typename?: 'Rating';
  comment: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  expertUid: Scalars['String']['output'];
  memberPseudo: Scalars['String']['output'];
  memberUid: Scalars['String']['output'];
  rate: Scalars['Int']['output'];
  ratingAnswer?: Maybe<RatingAnswer>;
  ratingUid: Scalars['ID']['output'];
};

export type RatingAnswer = {
  __typename?: 'RatingAnswer';
  comment?: Maybe<Scalars['String']['output']>;
  context: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  expertUid: Scalars['String']['output'];
  language?: Maybe<Scalars['String']['output']>;
  publishAt?: Maybe<Scalars['String']['output']>;
  ratingAnswerUid: Scalars['ID']['output'];
  ratingUid: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  validationComment?: Maybe<Scalars['String']['output']>;
  validationRules?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RatingFilters = {
  context: Scalars['String']['input'];
  expertUid?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  memberUid?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  rate?: InputMaybe<Scalars['Int']['input']>;
};

export type RatingList = {
  __typename?: 'RatingList';
  data: Array<Maybe<Rating>>;
  totalRows: Scalars['Int']['output'];
};

export type RatingSummary = {
  __typename?: 'RatingSummary';
  count: Scalars['Int']['output'];
  rate: Scalars['Int']['output'];
};

export type RatingSummaryFilters = {
  context: Scalars['String']['input'];
  expertUid?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};

export enum RefusalReason {
  CustomerRequest = 'CUSTOMER_REQUEST',
  Duplicate = 'DUPLICATE',
  Imprecise = 'IMPRECISE',
  Incomplete = 'INCOMPLETE',
  Insults = 'INSULTS',
  Other = 'OTHER',
  TechnicalIssue = 'TECHNICAL_ISSUE'
}

export type RelationInput = {
  relationRef?: InputMaybe<Scalars['String']['input']>;
  relationType?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsButton = {
  __typename?: 'SettingsButton';
  link?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export enum Skills {
  Astrology = 'ASTROLOGY',
  Cartomancy = 'CARTOMANCY',
  Clairvoyance = 'CLAIRVOYANCE',
  DreamsInterpretation = 'DREAMS_INTERPRETATION',
  Magnetism = 'MAGNETISM',
  Medium = 'MEDIUM',
  Numerology = 'NUMEROLOGY',
  Tarology = 'TAROLOGY'
}

export enum Status {
  Break = 'BREAK',
  Busy = 'BUSY',
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export type SupportMutations = {
  __typename?: 'SupportMutations';
  addTicketAnswer?: Maybe<Scalars['Boolean']['output']>;
  createTicket?: Maybe<Ticket>;
};


export type SupportMutationsAddTicketAnswerArgs = {
  ticketAnswer: TicketAnswerInput;
  ticketUid: Scalars['String']['input'];
};


export type SupportMutationsCreateTicketArgs = {
  createTicketInput: CreateTicketInput;
};

export type Survey = {
  __typename?: 'Survey';
  advertised?: Maybe<Scalars['Boolean']['output']>;
  context?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  language: Scalars['String']['output'];
  questions?: Maybe<Array<Maybe<Question>>>;
  singleResponse: Scalars['Boolean']['output'];
  startDate: Scalars['String']['output'];
  status: SurveyStatus;
  surveyUid?: Maybe<Scalars['ID']['output']>;
  targetQuery?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  userType?: Maybe<Scalars['String']['output']>;
};

export type SurveyMutations = {
  __typename?: 'SurveyMutations';
  createResponse?: Maybe<QuestionResponse>;
};


export type SurveyMutationsCreateResponseArgs = {
  questionUid: Scalars['ID']['input'];
  response: Array<InputMaybe<Scalars['String']['input']>>;
  responseUid: Scalars['ID']['input'];
};

export enum SurveyStatus {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Pulled = 'PULLED'
}

export type Ticket = {
  __typename?: 'Ticket';
  context?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  exchanges?: Maybe<Array<Maybe<TicketExchange>>>;
  language?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  ticketUid?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userFirstname?: Maybe<Scalars['String']['output']>;
  userLastname?: Maybe<Scalars['String']['output']>;
  userPseudo?: Maybe<Scalars['String']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
  userUid?: Maybe<Scalars['String']['output']>;
};

export type TicketAnswerInput = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content: Scalars['String']['input'];
};

export type TicketExchange = {
  __typename?: 'TicketExchange';
  attachments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  ticketExchangeUid?: Maybe<Scalars['String']['output']>;
  userPseudo?: Maybe<Scalars['String']['output']>;
};

export type TicketFilters = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type TicketRelation = {
  __typename?: 'TicketRelation';
  relationRef?: Maybe<Scalars['String']['output']>;
  relationType?: Maybe<Scalars['String']['output']>;
};

export type Translation = {
  __typename?: 'Translation';
  lang: Scalars['String']['output'];
  translation?: Maybe<Scalars['String']['output']>;
};

export type TrialConsultation = {
  __typename?: 'TrialConsultation';
  channel: Scalars['String']['output'];
  channelRefUid: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  expertUid: Scalars['String']['output'];
  feedback?: Maybe<ITrialConsultationFeedback>;
  language: Scalars['String']['output'];
  memberUid: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  trialConsultationUid: Scalars['ID']['output'];
  trialUid: Scalars['String']['output'];
};

export type TrialConsultationFeedback = {
  comment?: InputMaybe<Scalars['String']['input']>;
  globalQuality: Scalars['Int']['input'];
  listeningQuality: Scalars['Int']['input'];
  receptionQuality: Scalars['Int']['input'];
  recommandation: Scalars['Boolean']['input'];
  responseQuality: Scalars['Int']['input'];
};

export type TrialConsultationFilters = {
  expertUid?: InputMaybe<Scalars['String']['input']>;
  livechat?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  video?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TrialConsultationList = {
  __typename?: 'TrialConsultationList';
  data: Array<Maybe<TrialConsultation>>;
  totalRows: Scalars['Int']['output'];
};

export type TrialOffer = {
  __typename?: 'TrialOffer';
  channels: Array<Maybe<Scalars['String']['output']>>;
  expertUid: Scalars['String']['output'];
  memberUid: Scalars['String']['output'];
  trialOfferUid: Scalars['ID']['output'];
};

export type TrialOfferAction = {
  action: Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
  phoneUid?: InputMaybe<Scalars['String']['input']>;
};

export type TwilioMutations = {
  __typename?: 'TwilioMutations';
  stopCall: Scalars['Boolean']['output'];
};


export type TwilioMutationsStopCallArgs = {
  callLegUid?: InputMaybe<Scalars['String']['input']>;
  ivrCallUid?: InputMaybe<Scalars['String']['input']>;
};

export type UserFeedback = {
  __typename?: 'UserFeedback';
  feedback?: Maybe<Array<Maybe<Feedback>>>;
  userType?: Maybe<UserType>;
};

export type UserFeedbackMutations = {
  __typename?: 'UserFeedbackMutations';
  createUserFeedback?: Maybe<UserFeedback>;
};


export type UserFeedbackMutationsCreateUserFeedbackArgs = {
  feedbacks: Array<InputMaybe<FeedbackInput>>;
  recaptcha?: InputMaybe<Scalars['String']['input']>;
};

export enum UserType {
  Expert = 'EXPERT',
  Member = 'MEMBER',
  Visitor = 'VISITOR'
}

export type VideoParticipant = {
  __typename?: 'VideoParticipant';
  connectionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isMe: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  online: Scalars['Boolean']['output'];
  userUid: Scalars['String']['output'];
};

export type VideoRoom = {
  __typename?: 'VideoRoom';
  context?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  maxTime: Scalars['Int']['output'];
  participants: Array<Maybe<VideoParticipant>>;
  sessionId?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<VideoRoomStatus>;
  token?: Maybe<Scalars['String']['output']>;
  videoRoomUid: Scalars['ID']['output'];
};

export enum VideoRoomStatus {
  Canceled = 'CANCELED',
  Connected = 'CONNECTED',
  ConnectionLost = 'CONNECTION_LOST',
  Created = 'CREATED',
  Expired = 'EXPIRED',
  Finished = 'FINISHED',
  Initiated = 'INITIATED',
  Started = 'STARTED'
}

export type WelcomeOfferRedeemResult = {
  __typename?: 'WelcomeOfferRedeemResult';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Written = {
  __typename?: 'Written';
  answer?: Maybe<Scalars['String']['output']>;
  answeredAt?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt: Scalars['String']['output'];
  expertUid: Scalars['String']['output'];
  expireAt: Scalars['String']['output'];
  memberUid: Scalars['String']['output'];
  message: Scalars['String']['output'];
  refusalComment?: Maybe<Scalars['String']['output']>;
  refusalReason?: Maybe<RefusalReason>;
  status?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
  writtenUid: Scalars['ID']['output'];
};

export type GetAuthToken = {
  __typename?: 'getAuthToken';
  authToken: Scalars['String']['output'];
};

export type PasswordRecoveryMutationVariables = Exact<{
  email: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type PasswordRecoveryMutation = { __typename?: 'Mutation', authMutations?: { __typename?: 'AuthMutations', passwordRecovery?: boolean | null } | null };

export type PasswordResetMutationVariables = Exact<{
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type PasswordResetMutation = { __typename?: 'Mutation', authMutations?: { __typename?: 'AuthMutations', passwordReset?: boolean | null } | null };

export type CreateMemberMutationVariables = Exact<{
  input: MemberInput;
  consents: CreateMemberConsent;
}>;


export type CreateMemberMutation = { __typename?: 'Mutation', memberMutations?: { __typename?: 'MemberMutations', createMember?: { __typename?: 'Member', memberUid: string, profile?: { __typename?: 'MemberProfile', pseudo?: string | null, remainingTime?: number | null, memberCode?: string | null } | null, consents?: Array<{ __typename?: 'Consent', purposeUid: string, purposeKey: string, type: ConsentType, contentId?: string | null, required: boolean, userUid: string, value?: boolean | null } | null> | null } | null } | null };

export type UpdateMemberMutationVariables = Exact<{
  input: MemberInput;
}>;


export type UpdateMemberMutation = { __typename?: 'Mutation', memberMutations?: { __typename?: 'MemberMutations', updateMember?: { __typename?: 'Member', firstname?: string | null, lastname?: string | null, birthday?: string | null, email?: string | null, address?: string | null, complement?: string | null, zip?: string | null, city?: string | null, country?: string | null, region?: string | null, lang?: string | null, queueNotificationChannels?: Array<string | null> | null } | null } | null };

export type UpdatePseudoMutationVariables = Exact<{
  pseudo: Scalars['String']['input'];
}>;


export type UpdatePseudoMutation = { __typename?: 'Mutation', memberMutations?: { __typename?: 'MemberMutations', updatePseudo?: { __typename?: 'MemberProfile', pseudo?: string | null, memberCode?: string | null, remainingTime?: number | null, weeklyOrdersLimit?: number | null, favorites?: Array<string | null> | null, fidelityPoints?: number | null } | null } | null };

export type CloseAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type CloseAccountMutation = { __typename?: 'Mutation', memberMutations?: { __typename?: 'MemberMutations', closeAccount?: boolean | null } | null };

export type ChangeWeeklyOrdersLimitMutationVariables = Exact<{
  weeklyOrdersLimit: Scalars['Int']['input'];
}>;


export type ChangeWeeklyOrdersLimitMutation = { __typename?: 'Mutation', memberMutations?: { __typename?: 'MemberMutations', changeWeeklyOrdersLimit?: number | null } | null };

export type PaymentBlockingMutationVariables = Exact<{
  blockingRef: Scalars['String']['input'];
  blockingType: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaymentBlockingMutation = { __typename?: 'Mutation', paymentMutations?: { __typename?: 'PaymentMutations', paymentBlocking?: boolean | null } | null };

export type PaymentUnblockingMutationVariables = Exact<{
  paymentBlockingUid: Scalars['String']['input'];
}>;


export type PaymentUnblockingMutation = { __typename?: 'Mutation', paymentMutations?: { __typename?: 'PaymentMutations', paymentUnblocking?: boolean | null } | null };

export type ChangeConsentMutationVariables = Exact<{
  input: ConsentInput;
}>;


export type ChangeConsentMutation = { __typename?: 'Mutation', memberMutations?: { __typename?: 'MemberMutations', changeConsent?: { __typename?: 'Consent', purposeUid: string, purposeKey: string, type: ConsentType, contentId?: string | null, required: boolean, value?: boolean | null } | null } | null };

export type ChangeConsentsMutationVariables = Exact<{
  input: Array<InputMaybe<ConsentInput>> | InputMaybe<ConsentInput>;
}>;


export type ChangeConsentsMutation = { __typename?: 'Mutation', memberMutations?: { __typename?: 'MemberMutations', changeConsents?: Array<{ __typename?: 'Consent', purposeUid: string, purposeKey: string, type: ConsentType, contentId?: string | null, required: boolean, value?: boolean | null } | null> | null } | null };

export type ValidateCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
  codes: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  packUid: Scalars['String']['input'];
}>;


export type ValidateCodeMutation = { __typename?: 'Mutation', promotionMutations?: { __typename?: 'PromotionMutations', validatePromoCode?: { __typename?: 'PromoCode', promoCodeUid: string, code: string, type: string, value: number, cumulative?: boolean | null } | null } | null };

export type WelcomeOfferEligibilityMutationVariables = Exact<{ [key: string]: never; }>;


export type WelcomeOfferEligibilityMutation = { __typename?: 'Mutation', promotionMutations?: { __typename?: 'PromotionMutations', welcomeOfferEligibility?: boolean | null } | null };

export type WelcomeOfferRedeemMutationVariables = Exact<{ [key: string]: never; }>;


export type WelcomeOfferRedeemMutation = { __typename?: 'Mutation', promotionMutations?: { __typename?: 'PromotionMutations', welcomeOfferRedeem?: { __typename?: 'WelcomeOfferRedeemResult', error?: string | null, success: boolean } | null } | null };

export type CreateOrderMutationVariables = Exact<{
  input: CreateOrderInput;
  validateOrdersLimit?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', ordersMutations?: { __typename?: 'OrdersMutations', createOrder?: { __typename?: 'Order', orderId: string, paymentLink: string } | null } | null };

export type CreateConsultationWrittenMutationVariables = Exact<{
  input: ConsultationWrittenInput;
}>;


export type CreateConsultationWrittenMutation = { __typename?: 'Mutation', consultationMutations?: { __typename?: 'ConsultationMutations', createConsultationWritten?: { __typename?: 'Consultation', consultationUid: string, duration?: number | null } | null } | null };

export type PurgeConsultationMutationVariables = Exact<{
  consultationUid: Scalars['String']['input'];
}>;


export type PurgeConsultationMutation = { __typename?: 'Mutation', consultationMutations?: { __typename?: 'ConsultationMutations', purgeConsultation?: string | null } | null };

export type AddConsultationRatingMutationVariables = Exact<{
  input: ConsultationRatingInput;
}>;


export type AddConsultationRatingMutation = { __typename?: 'Mutation', consultationMutations?: { __typename?: 'ConsultationMutations', addConsultationRating?: { __typename?: 'ConsultationRating', ratingUid: string, rate: number, comment: string, refused?: boolean | null, moderation?: boolean | null, validationComment?: string | null, ratingAnswer?: { __typename?: 'RatingAnswer', ratingAnswerUid: string, ratingUid: string, expertUid: string, comment?: string | null, validationComment?: string | null, language?: string | null, status?: string | null, validationRules?: Array<string | null> | null, context: string, createdAt: string, updatedAt?: string | null, publishAt?: string | null } | null } | null } | null };

export type UpdateConsultationRatingMutationVariables = Exact<{
  ratingUid: Scalars['String']['input'];
  input: ConsultationRatingInput;
}>;


export type UpdateConsultationRatingMutation = { __typename?: 'Mutation', consultationMutations?: { __typename?: 'ConsultationMutations', updateConsultationRating?: { __typename?: 'ConsultationRating', ratingUid: string, rate: number, comment: string, createdAt: string, refused?: boolean | null, validationComment?: string | null, ratingAnswer?: { __typename?: 'RatingAnswer', ratingAnswerUid: string, ratingUid: string, expertUid: string, comment?: string | null, validationComment?: string | null, language?: string | null, status?: string | null, validationRules?: Array<string | null> | null, context: string, createdAt: string, updatedAt?: string | null, publishAt?: string | null } | null } | null } | null };

export type TrialOfferActionMutationVariables = Exact<{
  trialOfferUid: Scalars['String']['input'];
  action: TrialOfferAction;
}>;


export type TrialOfferActionMutation = { __typename?: 'Mutation', consultationMutations?: { __typename?: 'ConsultationMutations', trialOfferAction?: boolean | null } | null };

export type TrialConsultationFeedbackMutationVariables = Exact<{
  trialUid: Scalars['String']['input'];
  trialConsultationUid: Scalars['String']['input'];
  feedback?: InputMaybe<TrialConsultationFeedback>;
}>;


export type TrialConsultationFeedbackMutation = { __typename?: 'Mutation', consultationMutations?: { __typename?: 'ConsultationMutations', trialConsultationFeedback?: boolean | null } | null };

export type StopLivechatConsultationMutationVariables = Exact<{
  livechatRoomUid: Scalars['String']['input'];
}>;


export type StopLivechatConsultationMutation = { __typename?: 'Mutation', consultationMutations?: { __typename?: 'ConsultationMutations', stopLivechatConsultation?: boolean | null } | null };

export type StopVideoConsultationMutationVariables = Exact<{
  videoRoomUid: Scalars['String']['input'];
}>;


export type StopVideoConsultationMutation = { __typename?: 'Mutation', consultationMutations?: { __typename?: 'ConsultationMutations', stopVideoConsultation?: boolean | null } | null };

export type AddFavoriteMutationVariables = Exact<{
  favorite: Scalars['ID']['input'];
}>;


export type AddFavoriteMutation = { __typename?: 'Mutation', memberMutations?: { __typename?: 'MemberMutations', addFavorite?: string | null } | null };

export type RemoveFavoriteMutationVariables = Exact<{
  favorite: Scalars['ID']['input'];
}>;


export type RemoveFavoriteMutation = { __typename?: 'Mutation', memberMutations?: { __typename?: 'MemberMutations', removeFavorite?: string | null } | null };

export type AddAlertMutationVariables = Exact<{
  input: AddAlertInput;
}>;


export type AddAlertMutation = { __typename?: 'Mutation', memberMutations?: { __typename?: 'MemberMutations', addAlert?: { __typename?: 'MemberAlert', alertUid: string, expertUid: string, expertChannels: Array<string | null>, notificationChannels: Array<string | null>, validTo?: string | null } | null } | null };

export type EditAlertMutationVariables = Exact<{
  input: EditAlertInput;
}>;


export type EditAlertMutation = { __typename?: 'Mutation', memberMutations?: { __typename?: 'MemberMutations', editAlert?: { __typename?: 'MemberAlert', alertUid: string, expertUid: string, expertChannels: Array<string | null>, notificationChannels: Array<string | null>, validTo?: string | null } | null } | null };

export type RemoveAlertMutationVariables = Exact<{
  alertUid: Scalars['ID']['input'];
}>;


export type RemoveAlertMutation = { __typename?: 'Mutation', memberMutations?: { __typename?: 'MemberMutations', removeAlert?: boolean | null } | null };

export type RefreshPhoneNumberCodeMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
  language: Scalars['String']['input'];
  recaptcha: Scalars['String']['input'];
}>;


export type RefreshPhoneNumberCodeMutation = { __typename?: 'Mutation', memberMutations?: { __typename?: 'MemberMutations', refreshPhoneNumberCode?: { __typename?: 'PhoneNumber', phoneCode?: number | null, type?: string | null } | null } | null };

export type ValidatePhoneNumberMutationVariables = Exact<{
  input: PhoneNumberValidationInput;
}>;


export type ValidatePhoneNumberMutation = { __typename?: 'Mutation', memberMutations?: { __typename?: 'MemberMutations', validatePhoneNumber?: { __typename?: 'PhoneNumber', phoneUid: string, phoneNumber: string, country: string, carrier?: string | null, type?: string | null, status: boolean, phoneCode?: number | null, createdAt: string } | null } | null };

export type ValidateEmailMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ValidateEmailMutation = { __typename?: 'Mutation', memberMutations?: { __typename?: 'MemberMutations', validateEmail?: boolean | null } | null };

export type ChangeEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ChangeEmailMutation = { __typename?: 'Mutation', memberMutations?: { __typename?: 'MemberMutations', changeEmail?: boolean | null } | null };

export type SetPhoneNumberUsageMutationVariables = Exact<{
  phoneUid?: InputMaybe<Scalars['ID']['input']>;
  usage: Scalars['String']['input'];
}>;


export type SetPhoneNumberUsageMutation = { __typename?: 'Mutation', memberMutations?: { __typename?: 'MemberMutations', setPhoneNumberUsage?: boolean | null } | null };

export type RemovePhoneNumberMutationVariables = Exact<{
  phoneUid: Scalars['ID']['input'];
}>;


export type RemovePhoneNumberMutation = { __typename?: 'Mutation', memberMutations?: { __typename?: 'MemberMutations', removePhoneNumber?: string | null } | null };

export type CreateNotificationAckMutationVariables = Exact<{
  notificationUid: Scalars['String']['input'];
}>;


export type CreateNotificationAckMutation = { __typename?: 'Mutation', notificationMutations?: { __typename?: 'NotificationMutations', createNotificationAck?: { __typename?: 'NotificationAck', notificationUid: string } | null } | null };

export type CreateNotificationPushSubscriptionMutationVariables = Exact<{
  subscription: Scalars['String']['input'];
}>;


export type CreateNotificationPushSubscriptionMutation = { __typename?: 'Mutation', notificationMutations?: { __typename?: 'NotificationMutations', createNotificationPushSubscription?: boolean | null } | null };

export type AckAllNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type AckAllNotificationsMutation = { __typename?: 'Mutation', notificationMutations?: { __typename?: 'NotificationMutations', ackAllNotifications?: boolean | null } | null };

export type DeleteMessageMutationVariables = Exact<{
  messageUid: Scalars['String']['input'];
}>;


export type DeleteMessageMutation = { __typename?: 'Mutation', messagingMutations?: { __typename?: 'MessagingMutations', deleteMessage: boolean } | null };

export type CreateMessagesViewsMutationVariables = Exact<{
  messages: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreateMessagesViewsMutation = { __typename?: 'Mutation', messagingMutations?: { __typename?: 'MessagingMutations', createMessagesViews: boolean } | null };

export type CreateMessageMutationVariables = Exact<{
  recipient: Scalars['String']['input'];
  content: Scalars['String']['input'];
  language: Scalars['String']['input'];
  attachments?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CreateMessageMutation = { __typename?: 'Mutation', messagingMutations?: { __typename?: 'MessagingMutations', createMessage: { __typename?: 'Message', messageUid: string } } | null };

export type CreateBlockingMutationVariables = Exact<{
  action: Scalars['String']['input'];
  sender: Scalars['String']['input'];
}>;


export type CreateBlockingMutation = { __typename?: 'Mutation', messagingMutations?: { __typename?: 'MessagingMutations', createBlocking: boolean } | null };

export type SubscribeHoroscopeMutationVariables = Exact<{
  subscription: HoroscopeSubscription;
}>;


export type SubscribeHoroscopeMutation = { __typename?: 'Mutation', newslettersMutations?: { __typename?: 'NewslettersMutations', subscribeHoroscope?: boolean | null } | null };

export type StopCallMutationVariables = Exact<{
  callLegUid?: InputMaybe<Scalars['String']['input']>;
  ivrCallUid?: InputMaybe<Scalars['String']['input']>;
}>;


export type StopCallMutation = { __typename?: 'Mutation', twilioMutations?: { __typename?: 'TwilioMutations', stopCall: boolean } | null };

export type JoinQueueMutationVariables = Exact<{
  queueUid: Scalars['String']['input'];
  type: QueueType;
  expertUid: Scalars['String']['input'];
  phoneUid?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  memberPseudo?: InputMaybe<Scalars['String']['input']>;
  dropAt?: InputMaybe<Scalars['String']['input']>;
}>;


export type JoinQueueMutation = { __typename?: 'Mutation', queueMutations?: { __typename?: 'QueueMutations', joinQueue?: { __typename?: 'JoinQueueActionResult', success: boolean, queueItemUid?: string | null, memberPhoneUid?: string | null, servicePhone?: string | null } | null } | null };

export type DropQueueMutationVariables = Exact<{
  queueUid: Scalars['String']['input'];
  queueItemUid: Scalars['String']['input'];
}>;


export type DropQueueMutation = { __typename?: 'Mutation', queueMutations?: { __typename?: 'QueueMutations', dropQueue?: { __typename?: 'DropQueueResult', success: boolean } | null } | null };

export type EditQueueItemMutationVariables = Exact<{
  queueUid: Scalars['String']['input'];
  queueItemUid: Scalars['String']['input'];
  update: QueueItemUpdate;
}>;


export type EditQueueItemMutation = { __typename?: 'Mutation', queueMutations?: { __typename?: 'QueueMutations', editQueueItem?: boolean | null } | null };

export type CreateTicketMutationVariables = Exact<{
  createTicketInput: CreateTicketInput;
}>;


export type CreateTicketMutation = { __typename?: 'Mutation', supportMutations?: { __typename?: 'SupportMutations', createTicket?: { __typename?: 'Ticket', ticketUid?: string | null } | null } | null };

export type AddTicketAnswerMutationVariables = Exact<{
  ticketAnswer: TicketAnswerInput;
  ticketUid: Scalars['String']['input'];
}>;


export type AddTicketAnswerMutation = { __typename?: 'Mutation', supportMutations?: { __typename?: 'SupportMutations', addTicketAnswer?: boolean | null } | null };

export type AcknowledgeAdvisoryMutationVariables = Exact<{
  advisoryUid: Scalars['String']['input'];
}>;


export type AcknowledgeAdvisoryMutation = { __typename?: 'Mutation', advisoryMutations?: { __typename?: 'AdvisoryMutations', acknowledgeAdvisory?: boolean | null } | null };

export type AckAnnouncementsMutationVariables = Exact<{
  announcementUids: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type AckAnnouncementsMutation = { __typename?: 'Mutation', announcementMutations?: { __typename?: 'AnnouncementMutations', ackAnnouncements?: boolean | null } | null };

export type RespondToSurveyMutationVariables = Exact<{
  questionUid: Scalars['ID']['input'];
  response: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  responseUid: Scalars['ID']['input'];
}>;


export type RespondToSurveyMutation = { __typename?: 'Mutation', surveyMutations?: { __typename?: 'SurveyMutations', createResponse?: { __typename?: 'QuestionResponse', questionResponseUid?: string | null } | null } | null };

export type SendEventLogMutationVariables = Exact<{
  subject: Scalars['String']['input'];
  event: Scalars['String']['input'];
  level: Scalars['String']['input'];
  ts: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendEventLogMutation = { __typename?: 'Mutation', logsMutations?: { __typename?: 'LogsMutations', sendEventLog?: boolean | null } | null };

export type GetAuthTokenQueryVariables = Exact<{
  idToken: Scalars['String']['input'];
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAuthTokenQuery = { __typename?: 'Query', getAuthToken: { __typename?: 'getAuthToken', authToken: string } };

export type MemberQueryVariables = Exact<{ [key: string]: never; }>;


export type MemberQuery = { __typename?: 'Query', member?: { __typename?: 'Member', memberUid: string, firstname?: string | null, lastname?: string | null, birthday?: string | null, email?: string | null, address?: string | null, complement?: string | null, zip?: string | null, city?: string | null, country?: string | null, region?: string | null, lang?: string | null, consultedExperts?: Array<string | null> | null, profile?: { __typename?: 'MemberProfile', pseudo?: string | null, remainingTime?: number | null, memberCode?: string | null, weeklyOrdersLimit?: number | null, favorites?: Array<string | null> | null, fidelityPoints?: number | null, phoneUidForAlerts?: string | null, phoneUidLastUsed?: string | null, queueNotificationChannels?: Array<string | null> | null, createdAt?: string | null } | null, consents?: Array<{ __typename?: 'Consent', purposeUid: string, purposeKey: string, type: ConsentType, contentId?: string | null, required: boolean, requiresConsent?: boolean | null, lastModifiedAt?: string | null, consentDate?: string | null, userUid: string, value?: boolean | null, context: string } | null> | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', phoneUid: string, phoneNumber: string, country: string, type?: string | null, status: boolean, phoneCode?: number | null, servicePhones?: { __typename?: 'MemberServicePhones', calls?: string | null, sms?: string | null } | null } | null> | null, alerts?: Array<{ __typename?: 'MemberAlert', alertUid: string, expertUid: string, expertChannels: Array<string | null>, notificationChannels: Array<string | null>, validTo?: string | null } | null> | null } | null, activeSurveys?: Array<{ __typename?: 'Survey', surveyUid?: string | null, title: string, description?: string | null, language: string, createdAt: string, startDate: string, endDate?: string | null, targetQuery?: string | null, singleResponse: boolean, country?: string | null, status: SurveyStatus, context?: string | null, userType?: string | null, advertised?: boolean | null, questions?: Array<{ __typename?: 'Question', questionUid?: string | null, title: string, content?: string | null, required: boolean, showQuestion: boolean, showDescription: boolean, type: QuestionType, order?: number | null, settings: { __typename?: 'QuestionSettings', allowOther?: boolean | null, min?: number | null, max?: number | null, step?: number | null, minLabel?: string | null, midLabel?: string | null, maxLabel?: string | null, collectEmail?: boolean | null, options?: Array<{ __typename?: 'Option', key: string, label: string, action?: { __typename?: 'OptionAction', type: ActionType, questionUid?: string | null } | null }> | null, button?: { __typename?: 'SettingsButton', text?: string | null, link?: string | null } | null } } | null> | null } | null> | null, advisories?: { __typename?: 'PaginatedAdvisory', totalRows: number, data: Array<{ __typename?: 'Advisory', advisoryUid: string, type: string, createdAt: string } | null> } | null, announcements?: Array<{ __typename?: 'Announcement', announcementUid: string, type?: string | null, typeData: string, content: string, notify?: boolean | null, startDate: string, endDate?: string | null } | null> | null, pendingActions?: { __typename?: 'PendingActions', onGoingConsultation?: { __typename?: 'Consultation', expertUid: string, channel: string, channelRefUid: string, maxDuration?: number | null, consultationUid: string, createdAt: string, startDate?: string | null } | null, trialOffer?: { __typename?: 'TrialOffer', trialOfferUid: string, memberUid: string, expertUid: string, channels: Array<string | null> } | null, trialConsultation?: { __typename?: 'TrialConsultation', trialConsultationUid: string, expertUid: string, memberUid: string, channel: string, channelRefUid: string, language: string, trialUid: string, status: string, createdAt: string, startDate?: string | null } | null } | null, notification?: { __typename?: 'Notification', unreadNotificationsCount: number, notifications?: Array<{ __typename?: 'NotificationData', notificationUid: string, ack: boolean, notificationType: string, metadata: string, priority: boolean, createdAt: string } | null> | null } | null, userQueues?: Array<{ __typename?: 'AnonymizedQueueInfo', queueItemUid?: string | null, queueItemType?: QueueType | null, queueUid: string, targetUid: string, queuedAt: string, dropAt?: string | null, metadata?: { __typename?: 'QueueItemMetadata', servicePhone?: string | null, isEphemeral?: boolean | null, memberPhoneUid?: string | null } | null, items: Array<{ __typename?: 'QueueItem', position?: number | null, duration?: number | null, startedAt?: string | null, type?: string | null, metadata?: { __typename?: 'QueueItemMetadata', isEphemeral?: boolean | null } | null } | null> } | null> | null };

export type AdvisoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdvisoriesQuery = { __typename?: 'Query', advisories?: { __typename?: 'PaginatedAdvisory', totalRows: number, data: Array<{ __typename?: 'Advisory', advisoryUid: string, type: string, targetType: string, targetUid?: string | null, expiresAt?: string | null, createdAt: string } | null> } | null };

export type PendingActionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PendingActionsQuery = { __typename?: 'Query', pendingActions?: { __typename?: 'PendingActions', onGoingConsultation?: { __typename?: 'Consultation', expertUid: string, channel: string, channelRefUid: string, maxDuration?: number | null, consultationUid: string, createdAt: string, startDate?: string | null } | null, trialOffer?: { __typename?: 'TrialOffer', trialOfferUid: string, memberUid: string, expertUid: string, channels: Array<string | null> } | null, trialConsultation?: { __typename?: 'TrialConsultation', trialConsultationUid: string, expertUid: string, memberUid: string, channel: string, channelRefUid: string, language: string, trialUid: string, status: string, createdAt: string, startDate?: string | null } | null } | null };

export type ExpertQueryVariables = Exact<{
  expertUid: Scalars['ID']['input'];
  profileLanguage: Scalars['String']['input'];
}>;


export type ExpertQuery = { __typename?: 'Query', expert?: { __typename?: 'Expert', content?: { __typename?: 'ExpertContent', description?: string | null, writtenMessage?: string | null } | null } | null };

export type ExpertsIdentifiersQueryVariables = Exact<{
  profileLanguage: Scalars['String']['input'];
}>;


export type ExpertsIdentifiersQuery = { __typename?: 'Query', expertsIdentifiers?: Array<{ __typename?: 'ExpertIdentifiers', expertUid: string, pseudo?: string | null, expertCode?: string | null, picture?: string | null, online?: boolean | null, hidden?: boolean | null, status?: string | null, createdAt?: string | null } | null> | null };

export type ExpertsListQueryVariables = Exact<{
  expertFilters: ExpertListFilters;
}>;


export type ExpertsListQuery = { __typename?: 'Query', expertsList?: Array<string | null> | null };

export type ExpertsDataQueryVariables = Exact<{
  expertFilters: ExpertDataFilters;
}>;


export type ExpertsDataQuery = { __typename?: 'Query', expertsData?: Array<{ __typename?: 'Expert', expertUid: string, expertCode?: string | null, picture?: string | null, pseudo?: string | null, spokenLanguages?: Array<string | null> | null, vocalMessage?: string | null, quote?: string | null, createdAt?: string | null, skills?: Array<Skills | null> | null, totalConsultations?: number | null, totalRatings?: number | null, parameters?: { __typename?: 'ExpertParameters', phoneEnabled?: boolean | null, videoEnabled?: boolean | null, livechatEnabled?: boolean | null, writtenEnabled?: boolean | null, writtenLimit?: number | null } | null, presenceStatus?: { __typename?: 'ExpertStatus', phoneStatus?: boolean | null, videoStatus?: boolean | null, livechatStatus?: boolean | null, writtenStatus?: boolean | null, activityStatus?: boolean | null } | null, queue?: { __typename?: 'AnonymizedQueueInfo', queueUid: string, items: Array<{ __typename?: 'QueueItem', position?: number | null, duration?: number | null, startedAt?: string | null, type?: string | null, metadata?: { __typename?: 'QueueItemMetadata', isEphemeral?: boolean | null, maxDuration?: number | null } | null } | null> } | null, planning?: { __typename?: 'ExpertPlanningWeek', ownerUid: string, from?: string | null, to?: string | null, slots?: Array<{ __typename?: 'ExpertPlanningSlot', start?: string | null, end?: string | null, channels?: Array<ConsultationChannel | null> | null } | null> | null, queueSlots?: Array<{ __typename?: 'ExpertPlanningQueueSlot', start?: string | null, end?: string | null, channels?: Array<ConsultationChannel | null> | null } | null> | null } | null } | null> | null };

export type DailyHoroscopesQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type DailyHoroscopesQuery = { __typename?: 'Query', dailyHoroscopes?: Array<{ __typename?: 'DailyHoroscope', sign?: string | null, love?: string | null, money?: string | null, health?: string | null, quote?: string | null, work?: string | null, family?: string | null, socialLife?: string | null, luckyNumber?: number | null, main?: string | null, wink?: string | null } | null> | null };

export type ContentQueryQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  namespace: Scalars['String']['input'];
}>;


export type ContentQueryQuery = { __typename?: 'Query', content?: Array<{ __typename?: 'Content', key?: string | null, namespace?: string | null, content?: string | null } | null> | null };

export type PacksQueryVariables = Exact<{ [key: string]: never; }>;


export type PacksQuery = { __typename?: 'Query', packs?: Array<{ __typename?: 'Pack', packUid: string, name: string, time: number, color?: string | null, recommended: boolean, fidelityPoints: number, prices: Array<{ __typename?: 'PackPrice', currency: string, value: number } | null> } | null> | null };

export type PromotionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PromotionsQuery = { __typename?: 'Query', promotions?: Array<{ __typename?: 'Promotion', promoUid?: string | null, type?: PromoType | null, packs?: Array<string | null> | null, value?: number | null, startDate?: string | null, endDate?: string | null } | null> | null };

export type GlobalQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalQuery = { __typename?: 'Query', global?: { __typename?: 'Global', ipCountry?: string | null, boosts?: Array<{ __typename?: 'Boost', boostUid: string, channels: Array<BoostChannel | null>, value: number, startDate: string, endDate: string } | null> | null, promotions?: Array<{ __typename?: 'Promotion', promoUid?: string | null, type?: PromoType | null, packs?: Array<string | null> | null, value?: number | null, startDate?: string | null, endDate?: string | null } | null> | null } | null };

export type AnnouncementsQueryVariables = Exact<{
  announcementUid?: InputMaybe<Scalars['String']['input']>;
}>;


export type AnnouncementsQuery = { __typename?: 'Query', announcements?: Array<{ __typename?: 'Announcement', announcementUid: string, type?: string | null, typeData: string, content: string, notify?: boolean | null, startDate: string, endDate?: string | null } | null> | null };

export type PaymentQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
}>;


export type PaymentQuery = { __typename?: 'Query', paymentBlocking?: Array<{ __typename?: 'PaymentBlocking', createdAt?: string | null, updatedAt?: string | null, paymentBlockingUid?: string | null, ref?: string | null, status?: string | null, type?: string | null, metadata?: { __typename?: 'PaymentBlockingMetadata', orderRef?: string | null } | null } | null> | null, paymentCards?: Array<{ __typename?: 'PaymentCard', card: string, paymentMethodUid: string, orders: Array<{ __typename?: 'PaymentOrder', orderUid?: string | null, date?: string | null } | null> } | null> | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', blocked?: boolean | null, name: string, paymentMethodUid: string } | null> | null };

export type PaymentHostedTokenizationQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  paymentMethodUid: Scalars['String']['input'];
}>;


export type PaymentHostedTokenizationQuery = { __typename?: 'Query', paymentHostedTokenization?: { __typename?: 'HostedTokenization', url?: string | null, tokens?: Array<string | null> | null } | null };

export type OrderQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type OrderQuery = { __typename?: 'Query', order?: { __typename?: 'Order', orderId: string, promoUids?: Array<string | null> | null, netPrice: number, currency: string, time: number, status: string, createdAt: string, pack: { __typename?: 'Pack', packUid: string, name: string } } | null };

export type OrderRefreshQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type OrderRefreshQuery = { __typename?: 'Query', orderRefresh?: { __typename?: 'Order', orderId: string, paymentMethod: string, promoUids?: Array<string | null> | null, netPrice: number, currency: string, time: number, status: string, createdAt: string, firstPurchase?: boolean | null, pack: { __typename?: 'Pack', packUid: string, name: string, fidelityPoints: number } } | null };

export type OrdersQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type OrdersQuery = { __typename?: 'Query', orders?: { __typename?: 'OrderList', totalRows: number, data: Array<{ __typename?: 'Order', orderId: string, promoUids?: Array<string | null> | null, grossPrice: number, netPrice: number, currency: string, time: number, status: string, createdAt: string, pack: { __typename?: 'Pack', packUid: string, name: string } } | null> } | null };

export type ConsultationsQueryVariables = Exact<{
  filters?: InputMaybe<ConsultationFilters>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type ConsultationsQuery = { __typename?: 'Query', consultations?: { __typename?: 'ConsultationList', totalRows: number, data: Array<{ __typename?: 'Consultation', consultationUid: string, memberUid?: string | null, expertUid: string, language: string, duration?: number | null, channel: string, channelRefUid: string, status: string, startDate?: string | null, endDate?: string | null, createdAt: string, purgeDate?: string | null, rating?: { __typename?: 'ConsultationRating', ratingUid: string, rate: number, comment: string, postponed?: boolean | null, refused?: boolean | null, rejected?: boolean | null, moderation?: boolean | null, validationComment?: string | null, createdAt: string, ratingAnswer?: { __typename?: 'RatingAnswer', ratingAnswerUid: string, ratingUid: string, expertUid: string, comment?: string | null, validationComment?: string | null, language?: string | null, status?: string | null, validationRules?: Array<string | null> | null, context: string, createdAt: string, updatedAt?: string | null, publishAt?: string | null } | null } | null, boost?: { __typename?: 'Boost', boostUid: string, value: number } | null } | null> } | null };

export type ConsultationQueryVariables = Exact<{
  consultationUid: Scalars['String']['input'];
}>;


export type ConsultationQuery = { __typename?: 'Query', consultation?: { __typename?: 'Consultation', consultationUid: string, memberUid?: string | null, expertUid: string, language: string, duration?: number | null, channel: string, channelRefUid: string, status: string, failReason?: string | null, startDate?: string | null, endDate?: string | null, createdAt: string, purgeDate?: string | null, rating?: { __typename?: 'ConsultationRating', ratingUid: string, rate: number, comment: string, postponed?: boolean | null, refused?: boolean | null, rejected?: boolean | null, moderation?: boolean | null, validationComment?: string | null, ratingAnswer?: { __typename?: 'RatingAnswer', ratingAnswerUid: string, ratingUid: string, expertUid: string, comment?: string | null, validationComment?: string | null, language?: string | null, status?: string | null, validationRules?: Array<string | null> | null, context: string, createdAt: string, updatedAt?: string | null, publishAt?: string | null } | null } | null, boost?: { __typename?: 'Boost', boostUid: string, value: number } | null } | null };

export type TrialConsultationListQueryVariables = Exact<{
  filters?: InputMaybe<TrialConsultationFilters>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type TrialConsultationListQuery = { __typename?: 'Query', trialConsultations?: { __typename?: 'TrialConsultationList', totalRows: number, data: Array<{ __typename?: 'TrialConsultation', trialConsultationUid: string, channel: string, duration?: number | null, language: string, expertUid: string, memberUid: string, status: string, channelRefUid: string, startDate?: string | null, endDate?: string | null, createdAt: string, feedback?: { __typename?: 'ITrialConsultationFeedback', globalQuality?: number | null, receptionQuality?: number | null, responseQuality?: number | null, listeningQuality?: number | null, recommandation?: boolean | null, comment?: string | null } | null } | null> } | null };

export type TrialConsultationQueryVariables = Exact<{
  trialConsultationUid: Scalars['String']['input'];
}>;


export type TrialConsultationQuery = { __typename?: 'Query', trialConsultation?: { __typename?: 'TrialConsultation', trialConsultationUid: string, channel: string, duration?: number | null, language: string, expertUid: string, memberUid: string, status: string, channelRefUid: string, startDate?: string | null, endDate?: string | null, createdAt: string, feedback?: { __typename?: 'ITrialConsultationFeedback', globalQuality?: number | null, receptionQuality?: number | null, responseQuality?: number | null, listeningQuality?: number | null, recommandation?: boolean | null, comment?: string | null } | null } | null };

export type UserQueuesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQueuesQuery = { __typename?: 'Query', userQueues?: Array<{ __typename?: 'AnonymizedQueueInfo', queueItemUid?: string | null, queueItemType?: QueueType | null, queueUid: string, targetUid: string, queuedAt: string, dropAt?: string | null, metadata?: { __typename?: 'QueueItemMetadata', servicePhone?: string | null, isEphemeral?: boolean | null, memberPhoneUid?: string | null } | null, items: Array<{ __typename?: 'QueueItem', position?: number | null, duration?: number | null, startedAt?: string | null, type?: string | null, metadata?: { __typename?: 'QueueItemMetadata', isEphemeral?: boolean | null } | null } | null> } | null> | null };

export type RatingsQueryVariables = Exact<{
  filters?: InputMaybe<RatingFilters>;
}>;


export type RatingsQuery = { __typename?: 'Query', ratings?: { __typename?: 'RatingList', totalRows: number, data: Array<{ __typename?: 'Rating', ratingUid: string, expertUid: string, memberUid: string, memberPseudo: string, rate: number, comment: string, createdAt: string, ratingAnswer?: { __typename?: 'RatingAnswer', ratingAnswerUid: string, ratingUid: string, expertUid: string, comment?: string | null, validationComment?: string | null, language?: string | null, status?: string | null, validationRules?: Array<string | null> | null, context: string, createdAt: string, updatedAt?: string | null, publishAt?: string | null } | null } | null> } | null };

export type RatingsSummaryQueryVariables = Exact<{
  filters: RatingSummaryFilters;
}>;


export type RatingsSummaryQuery = { __typename?: 'Query', ratingsSummary?: Array<{ __typename?: 'RatingSummary', rate: number, count: number } | null> | null };

export type NotificationsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type NotificationsQuery = { __typename?: 'Query', notification?: { __typename?: 'Notification', unreadNotificationsCount: number, notifications?: Array<{ __typename?: 'NotificationData', notificationUid: string, ack: boolean, notificationType: string, metadata: string, createdAt: string } | null> | null } | null };

export type MessageAllowedQueryVariables = Exact<{
  correspondent: Scalars['String']['input'];
}>;


export type MessageAllowedQuery = { __typename?: 'Query', messageAllowed: boolean };

export type MessagesSummaryQueryVariables = Exact<{
  correspondent?: InputMaybe<Scalars['String']['input']>;
}>;


export type MessagesSummaryQuery = { __typename?: 'Query', messagesSummary: Array<{ __typename?: 'MessagesSummary', blocked: boolean, blockedBy: boolean, recipient: string, unreadMsg: number, lastMsgDate?: string | null }> };

export type MessagesListQueryVariables = Exact<{
  correspondent: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type MessagesListQuery = { __typename?: 'Query', messagesList: { __typename?: 'MessagesList', totalRows: number, data: Array<{ __typename?: 'Message', attachments?: Array<string> | null, content?: string | null, messageUid: string, sentAt: string, recipient: string, sender: string, refusalReason?: string | null, viewedAt?: string | null, deletedAt?: string | null }> } };

export type ExpertLimitsQueryVariables = Exact<{
  expertUid: Scalars['String']['input'];
}>;


export type ExpertLimitsQuery = { __typename?: 'Query', expertLimits?: { __typename?: 'ExpertLimits', availableMessageNbr?: number | null, consultationSecondCtr?: number | null } | null };

export type IvrCallsQueryVariables = Exact<{
  ivrCallUid?: InputMaybe<Scalars['String']['input']>;
}>;


export type IvrCallsQuery = { __typename?: 'Query', ivrCalls: { __typename?: 'IVRCall', ivrCallUid: string, memberCallUid?: string | null, memberPhone?: string | null, expertUid?: string | null, memberUid?: string | null } };

export type WrittenQueryVariables = Exact<{
  writtenUid: Scalars['ID']['input'];
}>;


export type WrittenQuery = { __typename?: 'Query', written?: { __typename?: 'Written', writtenUid: string, memberUid: string, expertUid: string, subject: string, message: string, attachments?: Array<string | null> | null, answer?: string | null, status?: string | null, refusalReason?: RefusalReason | null, refusalComment?: string | null, createdAt: string, answeredAt?: string | null, expireAt: string } | null };

export type LivechatRoomQueryVariables = Exact<{
  livechatRoomUid: Scalars['ID']['input'];
}>;


export type LivechatRoomQuery = { __typename?: 'Query', livechatRoom?: { __typename?: 'LivechatRoom', livechatRoomUid: string, maxTime: number, context?: string | null, createdAt?: string | null, startDate?: string | null, endDate?: string | null, status?: LivechatRoomStatus | null, participants: Array<{ __typename?: 'LivechatParticipant', name: string, userUid: string } | null>, messages?: Array<{ __typename?: 'LivechatRoomMessages', origin: string, ts: number, payload: string } | null> | null } | null };

export type VideoRoomQueryVariables = Exact<{
  videoRoomUid: Scalars['ID']['input'];
}>;


export type VideoRoomQuery = { __typename?: 'Query', videoRoom?: { __typename?: 'VideoRoom', videoRoomUid: string, maxTime: number, context?: string | null, createdAt?: string | null, startDate?: string | null, endDate?: string | null, sessionId?: string | null, token?: string | null, status?: VideoRoomStatus | null, participants: Array<{ __typename?: 'VideoParticipant', name: string, userUid: string, online: boolean, isMe: boolean, connectionIds?: Array<string | null> | null } | null> } | null };

export type DisplayPhonesQueryVariables = Exact<{
  usages: Array<InputMaybe<DisplayPhoneUsage>> | InputMaybe<DisplayPhoneUsage>;
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DisplayPhonesQuery = { __typename?: 'Query', displayPhones: Array<{ __typename?: 'DisplayPhone', phoneNumber: string, country?: string | null, usage: DisplayPhoneUsage, communications?: { __typename?: 'PhoneCommunications', phoneUsageUid?: string | null, callPrice?: string | null, callType?: string | null, callDisclaimer?: string | null, discontinuing?: string | null, unavailable?: string | null } | null } | null> };

export type TicketsQueryVariables = Exact<{
  filters?: InputMaybe<TicketFilters>;
}>;


export type TicketsQuery = { __typename?: 'Query', tickets?: { __typename?: 'PaginatedTickets', totalRows: number, data?: Array<{ __typename?: 'Ticket', userEmail?: string | null, ticketUid?: string | null, subject?: string | null, status?: string | null, userFirstname?: string | null, userLastname?: string | null, userPseudo?: string | null, createdAt?: string | null } | null> | null } | null };

export type TicketQueryVariables = Exact<{
  ticketUid: Scalars['String']['input'];
}>;


export type TicketQuery = { __typename?: 'Query', ticket?: { __typename?: 'Ticket', createdAt?: string | null, status?: string | null, subject?: string | null, userFirstname?: string | null, userLastname?: string | null, userEmail?: string | null, userPseudo?: string | null, userUid?: string | null, userType?: string | null, exchanges?: Array<{ __typename?: 'TicketExchange', ticketExchangeUid?: string | null, content?: string | null, origin?: string | null, createdAt?: string | null, attachments?: Array<string | null> | null, userPseudo?: string | null } | null> | null } | null };

export type GetActiveSurveysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveSurveysQuery = { __typename?: 'Query', activeSurveys?: Array<{ __typename?: 'Survey', surveyUid?: string | null, title: string, description?: string | null, language: string, createdAt: string, startDate: string, endDate?: string | null, targetQuery?: string | null, singleResponse: boolean, country?: string | null, status: SurveyStatus, context?: string | null, userType?: string | null, advertised?: boolean | null, questions?: Array<{ __typename?: 'Question', questionUid?: string | null, title: string, content?: string | null, required: boolean, showQuestion: boolean, showDescription: boolean, type: QuestionType, order?: number | null, settings: { __typename?: 'QuestionSettings', allowOther?: boolean | null, min?: number | null, max?: number | null, step?: number | null, minLabel?: string | null, midLabel?: string | null, maxLabel?: string | null, collectEmail?: boolean | null, options?: Array<{ __typename?: 'Option', key: string, label: string, action?: { __typename?: 'OptionAction', type: ActionType, questionUid?: string | null } | null }> | null, button?: { __typename?: 'SettingsButton', text?: string | null, link?: string | null } | null } } | null> | null } | null> | null };

export type ArticleQueryVariables = Exact<{
  articleUid: Scalars['ID']['input'];
}>;


export type ArticleQuery = { __typename?: 'Query', article?: { __typename?: 'Article', articleUid: string, authorUid: string, categoryUids: Array<string | null>, status: string, publishAt?: string | null, coverImageUrl?: string | null, shortLinkSlug?: string | null, reserved?: boolean | null, context?: string | null, imageAlts?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, coverImageUrls?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, postscript?: { __typename?: 'ArticlePostscript', newsletter?: boolean | null, signup?: boolean | null, app?: boolean | null } | null, content?: Array<{ __typename?: 'ArticleContent', articleContentUid: string, articleUid: string, readingTime?: number | null, status?: string | null, title?: string | null, body?: string | null, summary?: string | null, tldr?: string | null, nextTitle?: string | null, nextBody?: string | null, nextSummary?: string | null, nextTldr?: string | null, language?: string | null } | null> | null, author: { __typename?: 'Author', name: string, avatarUrl?: string | null, titleKey?: string | null, avatarUrls?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null }, categories?: Array<{ __typename?: 'ArticleCategory', categoryUid: string, titleKey?: string | null, color?: string | null, imageUrl?: string | null, imageUrls?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null } | null> | null } | null };

export type ArticleBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type ArticleBySlugQuery = { __typename?: 'Query', article?: { __typename?: 'Article', articleUid: string, authorUid: string, categoryUids: Array<string | null>, status: string, publishAt?: string | null, coverImageUrl?: string | null, shortLinkSlug?: string | null, reserved?: boolean | null, context?: string | null, imageAlts?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, coverImageUrls?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, postscript?: { __typename?: 'ArticlePostscript', newsletter?: boolean | null, signup?: boolean | null, app?: boolean | null } | null, content?: Array<{ __typename?: 'ArticleContent', articleContentUid: string, articleUid: string, readingTime?: number | null, status?: string | null, title?: string | null, body?: string | null, summary?: string | null, tldr?: string | null, nextTitle?: string | null, nextBody?: string | null, nextSummary?: string | null, nextTldr?: string | null, language?: string | null } | null> | null, author: { __typename?: 'Author', name: string, avatarUrl?: string | null, titleKey?: string | null, slug?: string | null, avatarUrls?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, titles?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null }, categories?: Array<{ __typename?: 'ArticleCategory', categoryUid: string, titleKey?: string | null, color?: string | null, imageUrl?: string | null, titles?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, imageAlts?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, slugs?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, marketingOffers?: Array<{ __typename?: 'MarketingOffer', titles?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, descriptions?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, imageUrls?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, imageAlts?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null } | null> | null, imageUrls?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null } | null> | null } | null };

export type ArticleSummariesQueryVariables = Exact<{
  filters: ArticleSummarySearch;
}>;


export type ArticleSummariesQuery = { __typename?: 'Query', articleSummaries?: { __typename?: 'ArticleSummaryList', totalRows: number, data: Array<{ __typename?: 'ArticleSummary', articleUid: string, categoryUids: Array<string | null>, status: string, publishAt: string, coverImageUrl?: string | null, shortLinkSlug?: string | null, reserved?: boolean | null, imageAlts?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, coverImageUrls?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, content: { __typename?: 'ArticleContentSummary', status: string, readingTime?: number | null, title: string, summary: string, slug: string }, author?: { __typename?: 'Author', slug?: string | null } | null, categories?: Array<{ __typename?: 'ArticleCategory', categoryUid: string, titleKey?: string | null, color?: string | null, imageUrl?: string | null, titles?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, slugs?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, imageUrls?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null } | null> | null } | null> } | null };

export type ArticlesCategoryBreakdownQueryVariables = Exact<{
  filters: ArticlesCategoryBreakdownSearch;
}>;


export type ArticlesCategoryBreakdownQuery = { __typename?: 'Query', articlesCategoryBreakdown?: Array<{ __typename?: 'ArticleCategoryBreakdown', categoryUid: string, titleKey: string, articleCount: number } | null> | null };

export type ArticleCategoriesQueryVariables = Exact<{
  filters: ArticleCategoriesSearch;
}>;


export type ArticleCategoriesQuery = { __typename?: 'Query', articleCategories?: Array<{ __typename?: 'ArticleCategory', categoryUid: string, titleKey?: string | null, color?: string | null, imageUrl?: string | null, titles?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, imageAlts?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, marketingOffers?: Array<{ __typename?: 'MarketingOffer', titles?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, descriptions?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, imageUrls?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, imageAlts?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null } | null> | null, slugs?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, descriptions?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, imageUrls?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null } | null> | null };

export type ArticleCategoryQueryVariables = Exact<{
  categoryUid?: InputMaybe<Scalars['ID']['input']>;
  titleKey?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type ArticleCategoryQuery = { __typename?: 'Query', articleCategory?: { __typename?: 'ArticleCategory', categoryUid: string, titleKey?: string | null, color?: string | null, imageUrl?: string | null, titles?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, imageAlts?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, marketingOffers?: Array<{ __typename?: 'MarketingOffer', titles?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, descriptions?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, imageUrls?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, imageAlts?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null } | null> | null, descriptions?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, slugs?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, imageUrls?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null } | null };

export type GetBlogAuthorQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetBlogAuthorQuery = { __typename?: 'Query', author?: { __typename?: 'Author', authorUid: string, name: string, avatarUrl?: string | null, titleKey?: string | null, context: string, slug?: string | null, avatarUrls?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, titles?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, descriptions?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null, imageAlts?: Array<{ __typename?: 'LocalisedField', key: string, value?: string | null } | null> | null } | null };

export type GetBlogAuthorOrCategoryQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type GetBlogAuthorOrCategoryQuery = { __typename?: 'Query', author?: { __typename?: 'Author', authorUid: string } | null, articleCategory?: { __typename?: 'ArticleCategory', categoryUid: string } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const PasswordRecoveryDocument = new TypedDocumentString(`
    mutation PasswordRecovery($email: String!, $language: String!) {
  authMutations {
    passwordRecovery(email: $email, language: $language)
  }
}
    `) as unknown as TypedDocumentString<PasswordRecoveryMutation, PasswordRecoveryMutationVariables>;
export const PasswordResetDocument = new TypedDocumentString(`
    mutation PasswordReset($code: String!, $password: String!) {
  authMutations {
    passwordReset(code: $code, password: $password)
  }
}
    `) as unknown as TypedDocumentString<PasswordResetMutation, PasswordResetMutationVariables>;
export const CreateMemberDocument = new TypedDocumentString(`
    mutation CreateMember($input: MemberInput!, $consents: CreateMemberConsent!) {
  memberMutations {
    createMember(input: $input, consents: $consents) {
      memberUid
      profile {
        pseudo
        remainingTime
        memberCode
      }
      consents {
        purposeUid
        purposeKey
        type
        contentId
        required
        userUid
        value
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CreateMemberMutation, CreateMemberMutationVariables>;
export const UpdateMemberDocument = new TypedDocumentString(`
    mutation UpdateMember($input: MemberInput!) {
  memberMutations {
    updateMember(input: $input) {
      firstname
      lastname
      birthday
      email
      address
      complement
      zip
      city
      country
      region
      lang
      queueNotificationChannels
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateMemberMutation, UpdateMemberMutationVariables>;
export const UpdatePseudoDocument = new TypedDocumentString(`
    mutation UpdatePseudo($pseudo: String!) {
  memberMutations {
    updatePseudo(pseudo: $pseudo) {
      pseudo
      memberCode
      remainingTime
      weeklyOrdersLimit
      favorites
      fidelityPoints
    }
  }
}
    `) as unknown as TypedDocumentString<UpdatePseudoMutation, UpdatePseudoMutationVariables>;
export const CloseAccountDocument = new TypedDocumentString(`
    mutation CloseAccount {
  memberMutations {
    closeAccount
  }
}
    `) as unknown as TypedDocumentString<CloseAccountMutation, CloseAccountMutationVariables>;
export const ChangeWeeklyOrdersLimitDocument = new TypedDocumentString(`
    mutation ChangeWeeklyOrdersLimit($weeklyOrdersLimit: Int!) {
  memberMutations {
    changeWeeklyOrdersLimit(weeklyOrdersLimit: $weeklyOrdersLimit)
  }
}
    `) as unknown as TypedDocumentString<ChangeWeeklyOrdersLimitMutation, ChangeWeeklyOrdersLimitMutationVariables>;
export const PaymentBlockingDocument = new TypedDocumentString(`
    mutation PaymentBlocking($blockingRef: String!, $blockingType: String!, $metadata: String) {
  paymentMutations {
    paymentBlocking(
      blockingRef: $blockingRef
      blockingType: $blockingType
      metadata: $metadata
    )
  }
}
    `) as unknown as TypedDocumentString<PaymentBlockingMutation, PaymentBlockingMutationVariables>;
export const PaymentUnblockingDocument = new TypedDocumentString(`
    mutation PaymentUnblocking($paymentBlockingUid: String!) {
  paymentMutations {
    paymentUnblocking(paymentBlockingUid: $paymentBlockingUid)
  }
}
    `) as unknown as TypedDocumentString<PaymentUnblockingMutation, PaymentUnblockingMutationVariables>;
export const ChangeConsentDocument = new TypedDocumentString(`
    mutation ChangeConsent($input: ConsentInput!) {
  memberMutations {
    changeConsent(input: $input) {
      purposeUid
      purposeKey
      type
      contentId
      required
      value
    }
  }
}
    `) as unknown as TypedDocumentString<ChangeConsentMutation, ChangeConsentMutationVariables>;
export const ChangeConsentsDocument = new TypedDocumentString(`
    mutation ChangeConsents($input: [ConsentInput]!) {
  memberMutations {
    changeConsents(input: $input) {
      purposeUid
      purposeKey
      type
      contentId
      required
      value
    }
  }
}
    `) as unknown as TypedDocumentString<ChangeConsentsMutation, ChangeConsentsMutationVariables>;
export const ValidateCodeDocument = new TypedDocumentString(`
    mutation ValidateCode($code: String!, $codes: [String]!, $packUid: String!) {
  promotionMutations {
    validatePromoCode(code: $code, codes: $codes, packUid: $packUid) {
      promoCodeUid
      code
      type
      value
      cumulative
    }
  }
}
    `) as unknown as TypedDocumentString<ValidateCodeMutation, ValidateCodeMutationVariables>;
export const WelcomeOfferEligibilityDocument = new TypedDocumentString(`
    mutation WelcomeOfferEligibility {
  promotionMutations {
    welcomeOfferEligibility
  }
}
    `) as unknown as TypedDocumentString<WelcomeOfferEligibilityMutation, WelcomeOfferEligibilityMutationVariables>;
export const WelcomeOfferRedeemDocument = new TypedDocumentString(`
    mutation WelcomeOfferRedeem {
  promotionMutations {
    welcomeOfferRedeem {
      error
      success
    }
  }
}
    `) as unknown as TypedDocumentString<WelcomeOfferRedeemMutation, WelcomeOfferRedeemMutationVariables>;
export const CreateOrderDocument = new TypedDocumentString(`
    mutation CreateOrder($input: CreateOrderInput!, $validateOrdersLimit: Boolean) {
  ordersMutations {
    createOrder(input: $input, validateOrdersLimit: $validateOrdersLimit) {
      orderId
      paymentLink
    }
  }
}
    `) as unknown as TypedDocumentString<CreateOrderMutation, CreateOrderMutationVariables>;
export const CreateConsultationWrittenDocument = new TypedDocumentString(`
    mutation CreateConsultationWritten($input: ConsultationWrittenInput!) {
  consultationMutations {
    createConsultationWritten(input: $input) {
      consultationUid
      duration
    }
  }
}
    `) as unknown as TypedDocumentString<CreateConsultationWrittenMutation, CreateConsultationWrittenMutationVariables>;
export const PurgeConsultationDocument = new TypedDocumentString(`
    mutation PurgeConsultation($consultationUid: String!) {
  consultationMutations {
    purgeConsultation(consultationUid: $consultationUid)
  }
}
    `) as unknown as TypedDocumentString<PurgeConsultationMutation, PurgeConsultationMutationVariables>;
export const AddConsultationRatingDocument = new TypedDocumentString(`
    mutation AddConsultationRating($input: ConsultationRatingInput!) {
  consultationMutations {
    addConsultationRating(input: $input) {
      ratingUid
      rate
      comment
      ratingAnswer {
        ratingAnswerUid
        ratingUid
        expertUid
        comment
        validationComment
        language
        status
        validationRules
        context
        createdAt
        updatedAt
        publishAt
      }
      refused
      moderation
      validationComment
    }
  }
}
    `) as unknown as TypedDocumentString<AddConsultationRatingMutation, AddConsultationRatingMutationVariables>;
export const UpdateConsultationRatingDocument = new TypedDocumentString(`
    mutation UpdateConsultationRating($ratingUid: String!, $input: ConsultationRatingInput!) {
  consultationMutations {
    updateConsultationRating(ratingUid: $ratingUid, input: $input) {
      ratingUid
      rate
      comment
      ratingAnswer {
        ratingAnswerUid
        ratingUid
        expertUid
        comment
        validationComment
        language
        status
        validationRules
        context
        createdAt
        updatedAt
        publishAt
      }
      createdAt
      refused
      validationComment
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateConsultationRatingMutation, UpdateConsultationRatingMutationVariables>;
export const TrialOfferActionDocument = new TypedDocumentString(`
    mutation TrialOfferAction($trialOfferUid: String!, $action: TrialOfferAction!) {
  consultationMutations {
    trialOfferAction(trialOfferUid: $trialOfferUid, action: $action)
  }
}
    `) as unknown as TypedDocumentString<TrialOfferActionMutation, TrialOfferActionMutationVariables>;
export const TrialConsultationFeedbackDocument = new TypedDocumentString(`
    mutation TrialConsultationFeedback($trialUid: String!, $trialConsultationUid: String!, $feedback: TrialConsultationFeedback) {
  consultationMutations {
    trialConsultationFeedback(
      trialUid: $trialUid
      trialConsultationUid: $trialConsultationUid
      feedback: $feedback
    )
  }
}
    `) as unknown as TypedDocumentString<TrialConsultationFeedbackMutation, TrialConsultationFeedbackMutationVariables>;
export const StopLivechatConsultationDocument = new TypedDocumentString(`
    mutation StopLivechatConsultation($livechatRoomUid: String!) {
  consultationMutations {
    stopLivechatConsultation(livechatRoomUid: $livechatRoomUid)
  }
}
    `) as unknown as TypedDocumentString<StopLivechatConsultationMutation, StopLivechatConsultationMutationVariables>;
export const StopVideoConsultationDocument = new TypedDocumentString(`
    mutation StopVideoConsultation($videoRoomUid: String!) {
  consultationMutations {
    stopVideoConsultation(videoRoomUid: $videoRoomUid)
  }
}
    `) as unknown as TypedDocumentString<StopVideoConsultationMutation, StopVideoConsultationMutationVariables>;
export const AddFavoriteDocument = new TypedDocumentString(`
    mutation AddFavorite($favorite: ID!) {
  memberMutations {
    addFavorite(favorite: $favorite)
  }
}
    `) as unknown as TypedDocumentString<AddFavoriteMutation, AddFavoriteMutationVariables>;
export const RemoveFavoriteDocument = new TypedDocumentString(`
    mutation RemoveFavorite($favorite: ID!) {
  memberMutations {
    removeFavorite(favorite: $favorite)
  }
}
    `) as unknown as TypedDocumentString<RemoveFavoriteMutation, RemoveFavoriteMutationVariables>;
export const AddAlertDocument = new TypedDocumentString(`
    mutation AddAlert($input: AddAlertInput!) {
  memberMutations {
    addAlert(input: $input) {
      alertUid
      expertUid
      expertChannels
      notificationChannels
      validTo
    }
  }
}
    `) as unknown as TypedDocumentString<AddAlertMutation, AddAlertMutationVariables>;
export const EditAlertDocument = new TypedDocumentString(`
    mutation EditAlert($input: EditAlertInput!) {
  memberMutations {
    editAlert(input: $input) {
      alertUid
      expertUid
      expertChannels
      notificationChannels
      validTo
    }
  }
}
    `) as unknown as TypedDocumentString<EditAlertMutation, EditAlertMutationVariables>;
export const RemoveAlertDocument = new TypedDocumentString(`
    mutation RemoveAlert($alertUid: ID!) {
  memberMutations {
    removeAlert(alertUid: $alertUid)
  }
}
    `) as unknown as TypedDocumentString<RemoveAlertMutation, RemoveAlertMutationVariables>;
export const RefreshPhoneNumberCodeDocument = new TypedDocumentString(`
    mutation RefreshPhoneNumberCode($phoneNumber: String!, $language: String!, $recaptcha: String!) {
  memberMutations {
    refreshPhoneNumberCode(
      phoneNumber: $phoneNumber
      language: $language
      recaptcha: $recaptcha
    ) {
      phoneCode
      type
    }
  }
}
    `) as unknown as TypedDocumentString<RefreshPhoneNumberCodeMutation, RefreshPhoneNumberCodeMutationVariables>;
export const ValidatePhoneNumberDocument = new TypedDocumentString(`
    mutation ValidatePhoneNumber($input: PhoneNumberValidationInput!) {
  memberMutations {
    validatePhoneNumber(input: $input) {
      phoneUid
      phoneNumber
      country
      carrier
      type
      status
      phoneCode
      createdAt
    }
  }
}
    `) as unknown as TypedDocumentString<ValidatePhoneNumberMutation, ValidatePhoneNumberMutationVariables>;
export const ValidateEmailDocument = new TypedDocumentString(`
    mutation ValidateEmail($code: String!) {
  memberMutations {
    validateEmail(code: $code)
  }
}
    `) as unknown as TypedDocumentString<ValidateEmailMutation, ValidateEmailMutationVariables>;
export const ChangeEmailDocument = new TypedDocumentString(`
    mutation ChangeEmail($email: String!) {
  memberMutations {
    changeEmail(email: $email)
  }
}
    `) as unknown as TypedDocumentString<ChangeEmailMutation, ChangeEmailMutationVariables>;
export const SetPhoneNumberUsageDocument = new TypedDocumentString(`
    mutation SetPhoneNumberUsage($phoneUid: ID, $usage: String!) {
  memberMutations {
    setPhoneNumberUsage(phoneUid: $phoneUid, usage: $usage)
  }
}
    `) as unknown as TypedDocumentString<SetPhoneNumberUsageMutation, SetPhoneNumberUsageMutationVariables>;
export const RemovePhoneNumberDocument = new TypedDocumentString(`
    mutation RemovePhoneNumber($phoneUid: ID!) {
  memberMutations {
    removePhoneNumber(phoneUid: $phoneUid)
  }
}
    `) as unknown as TypedDocumentString<RemovePhoneNumberMutation, RemovePhoneNumberMutationVariables>;
export const CreateNotificationAckDocument = new TypedDocumentString(`
    mutation CreateNotificationAck($notificationUid: String!) {
  notificationMutations {
    createNotificationAck(notificationUid: $notificationUid) {
      notificationUid
    }
  }
}
    `) as unknown as TypedDocumentString<CreateNotificationAckMutation, CreateNotificationAckMutationVariables>;
export const CreateNotificationPushSubscriptionDocument = new TypedDocumentString(`
    mutation CreateNotificationPushSubscription($subscription: String!) {
  notificationMutations {
    createNotificationPushSubscription(subscription: $subscription)
  }
}
    `) as unknown as TypedDocumentString<CreateNotificationPushSubscriptionMutation, CreateNotificationPushSubscriptionMutationVariables>;
export const AckAllNotificationsDocument = new TypedDocumentString(`
    mutation AckAllNotifications {
  notificationMutations {
    ackAllNotifications
  }
}
    `) as unknown as TypedDocumentString<AckAllNotificationsMutation, AckAllNotificationsMutationVariables>;
export const DeleteMessageDocument = new TypedDocumentString(`
    mutation DeleteMessage($messageUid: String!) {
  messagingMutations {
    deleteMessage(messageUid: $messageUid)
  }
}
    `) as unknown as TypedDocumentString<DeleteMessageMutation, DeleteMessageMutationVariables>;
export const CreateMessagesViewsDocument = new TypedDocumentString(`
    mutation CreateMessagesViews($messages: [String!]!) {
  messagingMutations {
    createMessagesViews(messages: $messages)
  }
}
    `) as unknown as TypedDocumentString<CreateMessagesViewsMutation, CreateMessagesViewsMutationVariables>;
export const CreateMessageDocument = new TypedDocumentString(`
    mutation CreateMessage($recipient: String!, $content: String!, $language: String!, $attachments: [String!]) {
  messagingMutations {
    createMessage(
      recipient: $recipient
      content: $content
      language: $language
      attachments: $attachments
    ) {
      messageUid
    }
  }
}
    `) as unknown as TypedDocumentString<CreateMessageMutation, CreateMessageMutationVariables>;
export const CreateBlockingDocument = new TypedDocumentString(`
    mutation CreateBlocking($action: String!, $sender: String!) {
  messagingMutations {
    createBlocking(action: $action, sender: $sender)
  }
}
    `) as unknown as TypedDocumentString<CreateBlockingMutation, CreateBlockingMutationVariables>;
export const SubscribeHoroscopeDocument = new TypedDocumentString(`
    mutation SubscribeHoroscope($subscription: HoroscopeSubscription!) {
  newslettersMutations {
    subscribeHoroscope(subscription: $subscription)
  }
}
    `) as unknown as TypedDocumentString<SubscribeHoroscopeMutation, SubscribeHoroscopeMutationVariables>;
export const StopCallDocument = new TypedDocumentString(`
    mutation StopCall($callLegUid: String, $ivrCallUid: String) {
  twilioMutations {
    stopCall(callLegUid: $callLegUid, ivrCallUid: $ivrCallUid)
  }
}
    `) as unknown as TypedDocumentString<StopCallMutation, StopCallMutationVariables>;
export const JoinQueueDocument = new TypedDocumentString(`
    mutation JoinQueue($queueUid: String!, $type: QueueType!, $expertUid: String!, $phoneUid: String, $language: String!, $memberPseudo: String, $dropAt: String) {
  queueMutations {
    joinQueue(
      queueUid: $queueUid
      type: $type
      expertUid: $expertUid
      phoneUid: $phoneUid
      language: $language
      memberPseudo: $memberPseudo
      dropAt: $dropAt
    ) {
      success
      queueItemUid
      memberPhoneUid
      servicePhone
    }
  }
}
    `) as unknown as TypedDocumentString<JoinQueueMutation, JoinQueueMutationVariables>;
export const DropQueueDocument = new TypedDocumentString(`
    mutation DropQueue($queueUid: String!, $queueItemUid: String!) {
  queueMutations {
    dropQueue(queueUid: $queueUid, queueItemUid: $queueItemUid) {
      success
    }
  }
}
    `) as unknown as TypedDocumentString<DropQueueMutation, DropQueueMutationVariables>;
export const EditQueueItemDocument = new TypedDocumentString(`
    mutation EditQueueItem($queueUid: String!, $queueItemUid: String!, $update: QueueItemUpdate!) {
  queueMutations {
    editQueueItem(queueUid: $queueUid, queueItemUid: $queueItemUid, update: $update)
  }
}
    `) as unknown as TypedDocumentString<EditQueueItemMutation, EditQueueItemMutationVariables>;
export const CreateTicketDocument = new TypedDocumentString(`
    mutation CreateTicket($createTicketInput: CreateTicketInput!) {
  supportMutations {
    createTicket(createTicketInput: $createTicketInput) {
      ticketUid
    }
  }
}
    `) as unknown as TypedDocumentString<CreateTicketMutation, CreateTicketMutationVariables>;
export const AddTicketAnswerDocument = new TypedDocumentString(`
    mutation AddTicketAnswer($ticketAnswer: TicketAnswerInput!, $ticketUid: String!) {
  supportMutations {
    addTicketAnswer(ticketAnswer: $ticketAnswer, ticketUid: $ticketUid)
  }
}
    `) as unknown as TypedDocumentString<AddTicketAnswerMutation, AddTicketAnswerMutationVariables>;
export const AcknowledgeAdvisoryDocument = new TypedDocumentString(`
    mutation AcknowledgeAdvisory($advisoryUid: String!) {
  advisoryMutations {
    acknowledgeAdvisory(advisoryUid: $advisoryUid)
  }
}
    `) as unknown as TypedDocumentString<AcknowledgeAdvisoryMutation, AcknowledgeAdvisoryMutationVariables>;
export const AckAnnouncementsDocument = new TypedDocumentString(`
    mutation AckAnnouncements($announcementUids: [String]!) {
  announcementMutations {
    ackAnnouncements(announcementUids: $announcementUids)
  }
}
    `) as unknown as TypedDocumentString<AckAnnouncementsMutation, AckAnnouncementsMutationVariables>;
export const RespondToSurveyDocument = new TypedDocumentString(`
    mutation RespondToSurvey($questionUid: ID!, $response: [String]!, $responseUid: ID!) {
  surveyMutations {
    createResponse(
      questionUid: $questionUid
      response: $response
      responseUid: $responseUid
    ) {
      questionResponseUid
    }
  }
}
    `) as unknown as TypedDocumentString<RespondToSurveyMutation, RespondToSurveyMutationVariables>;
export const SendEventLogDocument = new TypedDocumentString(`
    mutation SendEventLog($subject: String!, $event: String!, $level: String!, $ts: String!, $metadata: String) {
  logsMutations {
    sendEventLog(
      subject: $subject
      event: $event
      level: $level
      ts: $ts
      metadata: $metadata
    )
  }
}
    `) as unknown as TypedDocumentString<SendEventLogMutation, SendEventLogMutationVariables>;
export const GetAuthTokenDocument = new TypedDocumentString(`
    query GetAuthToken($idToken: String!, $rememberMe: Boolean) {
  getAuthToken(idToken: $idToken, rememberMe: $rememberMe) {
    authToken
  }
}
    `) as unknown as TypedDocumentString<GetAuthTokenQuery, GetAuthTokenQueryVariables>;
export const MemberDocument = new TypedDocumentString(`
    query Member {
  member {
    memberUid
    firstname
    lastname
    birthday
    email
    address
    complement
    zip
    city
    country
    region
    lang
    profile {
      pseudo
      remainingTime
      memberCode
      weeklyOrdersLimit
      favorites
      fidelityPoints
      phoneUidForAlerts
      phoneUidLastUsed
      queueNotificationChannels
      createdAt
    }
    consents {
      purposeUid
      purposeKey
      type
      contentId
      required
      requiresConsent
      lastModifiedAt
      consentDate
      userUid
      value
      context
    }
    phoneNumbers {
      phoneUid
      phoneNumber
      country
      type
      status
      phoneCode
      servicePhones {
        calls
        sms
      }
    }
    consultedExperts
    alerts {
      alertUid
      expertUid
      expertChannels
      notificationChannels
      validTo
    }
  }
  activeSurveys {
    surveyUid
    title
    description
    language
    createdAt
    startDate
    endDate
    targetQuery
    singleResponse
    country
    status
    context
    userType
    advertised
    questions {
      questionUid
      title
      content
      required
      showQuestion
      showDescription
      type
      settings {
        allowOther
        options {
          key
          label
          action {
            type
            questionUid
          }
        }
        min
        max
        step
        minLabel
        midLabel
        maxLabel
        collectEmail
        button {
          text
          link
        }
      }
      order
    }
  }
  advisories {
    data {
      advisoryUid
      type
      createdAt
    }
    totalRows
  }
  announcements {
    announcementUid
    type
    typeData
    content
    notify
    startDate
    endDate
  }
  pendingActions {
    onGoingConsultation {
      expertUid
      channel
      channelRefUid
      maxDuration
      consultationUid
      createdAt
      startDate
    }
    trialOffer {
      trialOfferUid
      memberUid
      expertUid
      channels
    }
    trialConsultation {
      trialConsultationUid
      expertUid
      memberUid
      channel
      channelRefUid
      language
      trialUid
      status
      createdAt
      startDate
    }
  }
  notification {
    notifications {
      notificationUid
      ack
      notificationType
      metadata
      priority
      createdAt
    }
    unreadNotificationsCount
  }
  userQueues {
    queueItemUid
    queueItemType
    queueUid
    targetUid
    queuedAt
    dropAt
    metadata {
      servicePhone
      isEphemeral
      memberPhoneUid
    }
    items {
      position
      duration
      startedAt
      type
      metadata {
        isEphemeral
      }
    }
  }
}
    `) as unknown as TypedDocumentString<MemberQuery, MemberQueryVariables>;
export const AdvisoriesDocument = new TypedDocumentString(`
    query Advisories {
  advisories {
    data {
      advisoryUid
      type
      targetType
      targetUid
      expiresAt
      createdAt
    }
    totalRows
  }
}
    `) as unknown as TypedDocumentString<AdvisoriesQuery, AdvisoriesQueryVariables>;
export const PendingActionsDocument = new TypedDocumentString(`
    query PendingActions {
  pendingActions {
    onGoingConsultation {
      expertUid
      channel
      channelRefUid
      maxDuration
      consultationUid
      createdAt
      startDate
    }
    trialOffer {
      trialOfferUid
      memberUid
      expertUid
      channels
    }
    trialConsultation {
      trialConsultationUid
      expertUid
      memberUid
      channel
      channelRefUid
      language
      trialUid
      status
      createdAt
      startDate
    }
  }
}
    `) as unknown as TypedDocumentString<PendingActionsQuery, PendingActionsQueryVariables>;
export const ExpertDocument = new TypedDocumentString(`
    query Expert($expertUid: ID!, $profileLanguage: String!) {
  expert(expertUid: $expertUid, profileLanguage: $profileLanguage) {
    content {
      description
      writtenMessage
    }
  }
}
    `) as unknown as TypedDocumentString<ExpertQuery, ExpertQueryVariables>;
export const ExpertsIdentifiersDocument = new TypedDocumentString(`
    query ExpertsIdentifiers($profileLanguage: String!) {
  expertsIdentifiers(profileLanguage: $profileLanguage) {
    expertUid
    pseudo
    expertCode
    picture
    online
    hidden
    status
    createdAt
  }
}
    `) as unknown as TypedDocumentString<ExpertsIdentifiersQuery, ExpertsIdentifiersQueryVariables>;
export const ExpertsListDocument = new TypedDocumentString(`
    query ExpertsList($expertFilters: ExpertListFilters!) {
  expertsList(expertFilters: $expertFilters)
}
    `) as unknown as TypedDocumentString<ExpertsListQuery, ExpertsListQueryVariables>;
export const ExpertsDataDocument = new TypedDocumentString(`
    query ExpertsData($expertFilters: ExpertDataFilters!) {
  expertsData(expertFilters: $expertFilters) {
    expertUid
    expertCode
    picture
    pseudo
    spokenLanguages
    vocalMessage
    quote
    createdAt
    parameters {
      phoneEnabled
      videoEnabled
      livechatEnabled
      writtenEnabled
      writtenLimit
    }
    presenceStatus {
      phoneStatus
      videoStatus
      livechatStatus
      writtenStatus
      activityStatus
    }
    skills
    totalConsultations
    totalRatings
    queue {
      queueUid
      items {
        position
        duration
        startedAt
        type
        metadata {
          isEphemeral
          maxDuration
        }
      }
    }
    planning {
      ownerUid
      from
      to
      slots {
        start
        end
        channels
      }
      queueSlots {
        start
        end
        channels
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ExpertsDataQuery, ExpertsDataQueryVariables>;
export const DailyHoroscopesDocument = new TypedDocumentString(`
    query DailyHoroscopes($locale: String!, $timezone: String) {
  dailyHoroscopes(locale: $locale, timezone: $timezone) {
    sign
    love
    money
    health
    quote
    work
    family
    socialLife
    luckyNumber
    main
    wink
  }
}
    `) as unknown as TypedDocumentString<DailyHoroscopesQuery, DailyHoroscopesQueryVariables>;
export const ContentQueryDocument = new TypedDocumentString(`
    query ContentQuery($locale: String!, $key: String, $namespace: String!) {
  content(locale: $locale, key: $key, namespace: $namespace) {
    key
    namespace
    content
  }
}
    `) as unknown as TypedDocumentString<ContentQueryQuery, ContentQueryQueryVariables>;
export const PacksDocument = new TypedDocumentString(`
    query Packs {
  packs {
    packUid
    name
    time
    prices {
      currency
      value
    }
    color
    recommended
    fidelityPoints
  }
}
    `) as unknown as TypedDocumentString<PacksQuery, PacksQueryVariables>;
export const PromotionsDocument = new TypedDocumentString(`
    query Promotions {
  promotions {
    promoUid
    type
    packs
    value
    startDate
    endDate
  }
}
    `) as unknown as TypedDocumentString<PromotionsQuery, PromotionsQueryVariables>;
export const GlobalDocument = new TypedDocumentString(`
    query Global {
  global {
    boosts {
      boostUid
      channels
      value
      startDate
      endDate
    }
    promotions {
      promoUid
      type
      packs
      value
      startDate
      endDate
    }
    ipCountry
  }
}
    `) as unknown as TypedDocumentString<GlobalQuery, GlobalQueryVariables>;
export const AnnouncementsDocument = new TypedDocumentString(`
    query Announcements($announcementUid: String) {
  announcements(announcementUid: $announcementUid) {
    announcementUid
    type
    typeData
    content
    notify
    startDate
    endDate
  }
}
    `) as unknown as TypedDocumentString<AnnouncementsQuery, AnnouncementsQueryVariables>;
export const PaymentDocument = new TypedDocumentString(`
    query Payment($countryCode: String!) {
  paymentBlocking {
    createdAt
    updatedAt
    paymentBlockingUid
    ref
    status
    type
    metadata {
      orderRef
    }
  }
  paymentCards {
    card
    paymentMethodUid
    orders {
      orderUid
      date
    }
  }
  paymentMethods(countryCode: $countryCode) {
    blocked
    name
    paymentMethodUid
  }
}
    `) as unknown as TypedDocumentString<PaymentQuery, PaymentQueryVariables>;
export const PaymentHostedTokenizationDocument = new TypedDocumentString(`
    query PaymentHostedTokenization($locale: String!, $paymentMethodUid: String!) {
  paymentHostedTokenization(locale: $locale, paymentMethodUid: $paymentMethodUid) {
    url
    tokens
  }
}
    `) as unknown as TypedDocumentString<PaymentHostedTokenizationQuery, PaymentHostedTokenizationQueryVariables>;
export const OrderDocument = new TypedDocumentString(`
    query Order($orderId: String!) {
  order(orderId: $orderId) {
    orderId
    pack {
      packUid
      name
    }
    promoUids
    netPrice
    currency
    time
    status
    createdAt
  }
}
    `) as unknown as TypedDocumentString<OrderQuery, OrderQueryVariables>;
export const OrderRefreshDocument = new TypedDocumentString(`
    query OrderRefresh($orderId: String!) {
  orderRefresh(orderId: $orderId) {
    orderId
    pack {
      packUid
      name
      fidelityPoints
    }
    paymentMethod
    promoUids
    netPrice
    currency
    time
    status
    createdAt
    firstPurchase
  }
}
    `) as unknown as TypedDocumentString<OrderRefreshQuery, OrderRefreshQueryVariables>;
export const OrdersDocument = new TypedDocumentString(`
    query Orders($limit: Int!, $offset: Int!) {
  orders(limit: $limit, offset: $offset) {
    totalRows
    data {
      orderId
      pack {
        packUid
        name
      }
      promoUids
      grossPrice
      netPrice
      currency
      time
      status
      createdAt
    }
  }
}
    `) as unknown as TypedDocumentString<OrdersQuery, OrdersQueryVariables>;
export const ConsultationsDocument = new TypedDocumentString(`
    query Consultations($filters: ConsultationFilters, $limit: Int!, $offset: Int!) {
  consultations(filters: $filters, limit: $limit, offset: $offset) {
    totalRows
    data {
      consultationUid
      memberUid
      expertUid
      language
      duration
      channel
      channelRefUid
      status
      rating {
        ratingUid
        rate
        comment
        ratingAnswer {
          ratingAnswerUid
          ratingUid
          expertUid
          comment
          validationComment
          language
          status
          validationRules
          context
          createdAt
          updatedAt
          publishAt
        }
        postponed
        refused
        rejected
        moderation
        validationComment
        createdAt
      }
      startDate
      endDate
      createdAt
      purgeDate
      boost {
        boostUid
        value
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ConsultationsQuery, ConsultationsQueryVariables>;
export const ConsultationDocument = new TypedDocumentString(`
    query Consultation($consultationUid: String!) {
  consultation(consultationUid: $consultationUid) {
    consultationUid
    memberUid
    expertUid
    language
    duration
    channel
    channelRefUid
    status
    rating {
      ratingUid
      rate
      comment
      ratingAnswer {
        ratingAnswerUid
        ratingUid
        expertUid
        comment
        validationComment
        language
        status
        validationRules
        context
        createdAt
        updatedAt
        publishAt
      }
      postponed
      refused
      rejected
      moderation
      validationComment
    }
    failReason
    startDate
    endDate
    createdAt
    purgeDate
    boost {
      boostUid
      value
    }
  }
}
    `) as unknown as TypedDocumentString<ConsultationQuery, ConsultationQueryVariables>;
export const TrialConsultationListDocument = new TypedDocumentString(`
    query TrialConsultationList($filters: TrialConsultationFilters, $limit: Int!, $offset: Int!) {
  trialConsultations(filters: $filters, limit: $limit, offset: $offset) {
    totalRows
    data {
      trialConsultationUid
      channel
      duration
      feedback {
        globalQuality
        receptionQuality
        responseQuality
        listeningQuality
        recommandation
        comment
      }
      language
      expertUid
      memberUid
      status
      channelRefUid
      startDate
      endDate
      createdAt
    }
  }
}
    `) as unknown as TypedDocumentString<TrialConsultationListQuery, TrialConsultationListQueryVariables>;
export const TrialConsultationDocument = new TypedDocumentString(`
    query TrialConsultation($trialConsultationUid: String!) {
  trialConsultation(trialConsultationUid: $trialConsultationUid) {
    trialConsultationUid
    channel
    duration
    feedback {
      globalQuality
      receptionQuality
      responseQuality
      listeningQuality
      recommandation
      comment
    }
    language
    expertUid
    memberUid
    status
    channelRefUid
    startDate
    endDate
    createdAt
  }
}
    `) as unknown as TypedDocumentString<TrialConsultationQuery, TrialConsultationQueryVariables>;
export const UserQueuesDocument = new TypedDocumentString(`
    query UserQueues {
  userQueues {
    queueItemUid
    queueItemType
    queueUid
    targetUid
    queuedAt
    dropAt
    metadata {
      servicePhone
      isEphemeral
      memberPhoneUid
    }
    items {
      position
      duration
      startedAt
      type
      metadata {
        isEphemeral
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UserQueuesQuery, UserQueuesQueryVariables>;
export const RatingsDocument = new TypedDocumentString(`
    query Ratings($filters: RatingFilters) {
  ratings(filters: $filters) {
    totalRows
    data {
      ratingUid
      expertUid
      memberUid
      memberPseudo
      rate
      comment
      ratingAnswer {
        ratingAnswerUid
        ratingUid
        expertUid
        comment
        validationComment
        language
        status
        validationRules
        context
        createdAt
        updatedAt
        publishAt
      }
      createdAt
    }
  }
}
    `) as unknown as TypedDocumentString<RatingsQuery, RatingsQueryVariables>;
export const RatingsSummaryDocument = new TypedDocumentString(`
    query RatingsSummary($filters: RatingSummaryFilters!) {
  ratingsSummary(filters: $filters) {
    rate
    count
  }
}
    `) as unknown as TypedDocumentString<RatingsSummaryQuery, RatingsSummaryQueryVariables>;
export const NotificationsDocument = new TypedDocumentString(`
    query Notifications($offset: Int, $limit: Int) {
  notification {
    notifications(offset: $offset, limit: $limit) {
      notificationUid
      ack
      notificationType
      metadata
      createdAt
    }
    unreadNotificationsCount
  }
}
    `) as unknown as TypedDocumentString<NotificationsQuery, NotificationsQueryVariables>;
export const MessageAllowedDocument = new TypedDocumentString(`
    query MessageAllowed($correspondent: String!) {
  messageAllowed(correspondent: $correspondent)
}
    `) as unknown as TypedDocumentString<MessageAllowedQuery, MessageAllowedQueryVariables>;
export const MessagesSummaryDocument = new TypedDocumentString(`
    query MessagesSummary($correspondent: String) {
  messagesSummary(correspondent: $correspondent) {
    blocked
    blockedBy
    recipient
    unreadMsg
    lastMsgDate
  }
}
    `) as unknown as TypedDocumentString<MessagesSummaryQuery, MessagesSummaryQueryVariables>;
export const MessagesListDocument = new TypedDocumentString(`
    query MessagesList($correspondent: String!, $limit: Int!, $offset: Int!) {
  messagesList(correspondent: $correspondent, limit: $limit, offset: $offset) {
    totalRows
    data {
      attachments
      content
      messageUid
      sentAt
      recipient
      sender
      refusalReason
      viewedAt
      deletedAt
    }
  }
}
    `) as unknown as TypedDocumentString<MessagesListQuery, MessagesListQueryVariables>;
export const ExpertLimitsDocument = new TypedDocumentString(`
    query ExpertLimits($expertUid: String!) {
  expertLimits(expertUid: $expertUid) {
    availableMessageNbr
    consultationSecondCtr
  }
}
    `) as unknown as TypedDocumentString<ExpertLimitsQuery, ExpertLimitsQueryVariables>;
export const IvrCallsDocument = new TypedDocumentString(`
    query IvrCalls($ivrCallUid: String) {
  ivrCalls(ivrCallUid: $ivrCallUid) {
    ivrCallUid
    memberCallUid
    memberPhone
    expertUid
    memberUid
  }
}
    `) as unknown as TypedDocumentString<IvrCallsQuery, IvrCallsQueryVariables>;
export const WrittenDocument = new TypedDocumentString(`
    query Written($writtenUid: ID!) {
  written(writtenUid: $writtenUid) {
    writtenUid
    memberUid
    expertUid
    subject
    message
    attachments
    answer
    status
    refusalReason
    refusalComment
    createdAt
    answeredAt
    expireAt
  }
}
    `) as unknown as TypedDocumentString<WrittenQuery, WrittenQueryVariables>;
export const LivechatRoomDocument = new TypedDocumentString(`
    query LivechatRoom($livechatRoomUid: ID!) {
  livechatRoom(livechatRoomUid: $livechatRoomUid) {
    livechatRoomUid
    participants {
      name
      userUid
    }
    messages {
      origin
      ts
      payload
    }
    maxTime
    context
    createdAt
    startDate
    endDate
    status
  }
}
    `) as unknown as TypedDocumentString<LivechatRoomQuery, LivechatRoomQueryVariables>;
export const VideoRoomDocument = new TypedDocumentString(`
    query VideoRoom($videoRoomUid: ID!) {
  videoRoom(videoRoomUid: $videoRoomUid) {
    videoRoomUid
    maxTime
    context
    createdAt
    startDate
    endDate
    participants {
      name
      userUid
      online
      isMe
      connectionIds
    }
    sessionId
    token
    status
  }
}
    `) as unknown as TypedDocumentString<VideoRoomQuery, VideoRoomQueryVariables>;
export const DisplayPhonesDocument = new TypedDocumentString(`
    query DisplayPhones($usages: [DisplayPhoneUsage]!, $languages: [String], $countries: [String]) {
  displayPhones(usages: $usages, languages: $languages, countries: $countries) {
    phoneNumber
    country
    usage
    communications {
      phoneUsageUid
      callPrice
      callType
      callDisclaimer
      discontinuing
      unavailable
    }
  }
}
    `) as unknown as TypedDocumentString<DisplayPhonesQuery, DisplayPhonesQueryVariables>;
export const TicketsDocument = new TypedDocumentString(`
    query Tickets($filters: TicketFilters) {
  tickets(filters: $filters) {
    data {
      userEmail
      ticketUid
      subject
      status
      userFirstname
      userLastname
      userPseudo
      createdAt
    }
    totalRows
  }
}
    `) as unknown as TypedDocumentString<TicketsQuery, TicketsQueryVariables>;
export const TicketDocument = new TypedDocumentString(`
    query Ticket($ticketUid: String!) {
  ticket(ticketUid: $ticketUid) {
    createdAt
    status
    subject
    userFirstname
    userLastname
    userEmail
    userPseudo
    userUid
    userType
    exchanges {
      ticketExchangeUid
      content
      origin
      createdAt
      attachments
      userPseudo
    }
  }
}
    `) as unknown as TypedDocumentString<TicketQuery, TicketQueryVariables>;
export const GetActiveSurveysDocument = new TypedDocumentString(`
    query GetActiveSurveys {
  activeSurveys {
    surveyUid
    title
    description
    language
    createdAt
    startDate
    endDate
    targetQuery
    singleResponse
    country
    status
    context
    userType
    advertised
    questions {
      questionUid
      title
      content
      required
      showQuestion
      showDescription
      type
      settings {
        allowOther
        options {
          key
          label
          action {
            type
            questionUid
          }
        }
        min
        max
        step
        minLabel
        midLabel
        maxLabel
        collectEmail
        button {
          text
          link
        }
      }
      order
    }
  }
}
    `) as unknown as TypedDocumentString<GetActiveSurveysQuery, GetActiveSurveysQueryVariables>;
export const ArticleDocument = new TypedDocumentString(`
    query Article($articleUid: ID!) {
  article(articleUid: $articleUid) {
    articleUid
    authorUid
    categoryUids
    status
    publishAt
    coverImageUrl
    imageAlts {
      key
      value
    }
    coverImageUrls {
      key
      value
    }
    shortLinkSlug
    reserved
    postscript {
      newsletter
      signup
      app
    }
    context
    content {
      articleContentUid
      articleUid
      readingTime
      status
      title
      body
      summary
      tldr
      nextTitle
      nextBody
      nextSummary
      nextTldr
      language
    }
    author {
      name
      avatarUrl
      avatarUrls {
        key
        value
      }
      titleKey
    }
    categories {
      categoryUid
      titleKey
      color
      imageUrl
      imageUrls {
        key
        value
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ArticleQuery, ArticleQueryVariables>;
export const ArticleBySlugDocument = new TypedDocumentString(`
    query ArticleBySlug($slug: String!, $language: String!) {
  article(slug: $slug, language: $language) {
    articleUid
    authorUid
    categoryUids
    status
    publishAt
    coverImageUrl
    imageAlts {
      key
      value
    }
    coverImageUrls {
      key
      value
    }
    shortLinkSlug
    reserved
    postscript {
      newsletter
      signup
      app
    }
    context
    content {
      articleContentUid
      articleUid
      readingTime
      status
      title
      body
      summary
      tldr
      nextTitle
      nextBody
      nextSummary
      nextTldr
      language
    }
    author {
      name
      avatarUrl
      avatarUrls {
        key
        value
      }
      titleKey
      titles {
        key
        value
      }
      slug
    }
    imageAlts {
      key
      value
    }
    categories {
      categoryUid
      titleKey
      titles {
        key
        value
      }
      imageAlts {
        key
        value
      }
      slugs {
        key
        value
      }
      marketingOffers {
        titles {
          key
          value
        }
        descriptions {
          key
          value
        }
        imageUrls {
          key
          value
        }
        imageAlts {
          key
          value
        }
      }
      color
      imageUrl
      imageUrls {
        key
        value
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ArticleBySlugQuery, ArticleBySlugQueryVariables>;
export const ArticleSummariesDocument = new TypedDocumentString(`
    query ArticleSummaries($filters: ArticleSummarySearch!) {
  articleSummaries(filters: $filters) {
    totalRows
    data {
      articleUid
      categoryUids
      status
      publishAt
      coverImageUrl
      imageAlts {
        key
        value
      }
      coverImageUrls {
        key
        value
      }
      shortLinkSlug
      reserved
      content {
        status
        readingTime
        title
        summary
        slug
      }
      author {
        slug
      }
      categories {
        categoryUid
        titleKey
        titles {
          key
          value
        }
        slugs {
          key
          value
        }
        color
        imageUrl
        imageUrls {
          key
          value
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ArticleSummariesQuery, ArticleSummariesQueryVariables>;
export const ArticlesCategoryBreakdownDocument = new TypedDocumentString(`
    query ArticlesCategoryBreakdown($filters: ArticlesCategoryBreakdownSearch!) {
  articlesCategoryBreakdown(filters: $filters) {
    categoryUid
    titleKey
    articleCount
  }
}
    `) as unknown as TypedDocumentString<ArticlesCategoryBreakdownQuery, ArticlesCategoryBreakdownQueryVariables>;
export const ArticleCategoriesDocument = new TypedDocumentString(`
    query ArticleCategories($filters: ArticleCategoriesSearch!) {
  articleCategories(filters: $filters) {
    categoryUid
    titleKey
    titles {
      key
      value
    }
    imageAlts {
      key
      value
    }
    marketingOffers {
      titles {
        key
        value
      }
      descriptions {
        key
        value
      }
      imageUrls {
        key
        value
      }
      imageAlts {
        key
        value
      }
    }
    slugs {
      key
      value
    }
    descriptions {
      key
      value
    }
    imageAlts {
      key
      value
    }
    color
    imageUrl
    imageUrls {
      key
      value
    }
  }
}
    `) as unknown as TypedDocumentString<ArticleCategoriesQuery, ArticleCategoriesQueryVariables>;
export const ArticleCategoryDocument = new TypedDocumentString(`
    query ArticleCategory($categoryUid: ID, $titleKey: String, $slug: String, $language: String) {
  articleCategory(
    categoryUid: $categoryUid
    titleKey: $titleKey
    slug: $slug
    language: $language
  ) {
    categoryUid
    titleKey
    titles {
      key
      value
    }
    imageAlts {
      key
      value
    }
    marketingOffers {
      titles {
        key
        value
      }
      descriptions {
        key
        value
      }
      imageUrls {
        key
        value
      }
      imageAlts {
        key
        value
      }
    }
    descriptions {
      key
      value
    }
    slugs {
      key
      value
    }
    color
    imageUrl
    imageUrls {
      key
      value
    }
  }
}
    `) as unknown as TypedDocumentString<ArticleCategoryQuery, ArticleCategoryQueryVariables>;
export const GetBlogAuthorDocument = new TypedDocumentString(`
    query GetBlogAuthor($slug: String!) {
  author(slug: $slug) {
    authorUid
    name
    avatarUrl
    avatarUrls {
      key
      value
    }
    titleKey
    titles {
      key
      value
    }
    descriptions {
      key
      value
    }
    imageAlts {
      key
      value
    }
    context
    slug
  }
}
    `) as unknown as TypedDocumentString<GetBlogAuthorQuery, GetBlogAuthorQueryVariables>;
export const GetBlogAuthorOrCategoryDocument = new TypedDocumentString(`
    query GetBlogAuthorOrCategory($slug: String!, $language: String!) {
  author(slug: $slug) {
    authorUid
  }
  articleCategory(slug: $slug, language: $language) {
    categoryUid
  }
}
    `) as unknown as TypedDocumentString<GetBlogAuthorOrCategoryQuery, GetBlogAuthorOrCategoryQueryVariables>;